import Enums from "@/enums/enums";
import userInfo from "@/function/userInfo";
import { GetIsDevelop, default as shareHelper } from "@/helper/shareHelper";
import router from "@/router";

const IsDevelop = GetIsDevelop();
export class Queue {
  constructor() {
    this.elements = {};
    this.head = 0;
    this.tail = 0;
  }
  enqueue(element) {
    this.elements[this.tail] = element;
    this.tail++;
  }
  dequeue() {
    const item = this.elements[this.head];
    delete this.elements[this.head];
    this.head++;
    return item;
  }
  peek() {
    return this.elements[this.head];
  }
  get length() {
    return this.tail - this.head;
  }
  get isEmpty() {
    return this.length === 0;
  }
}

function GetInvoiceReceiptCreateStatus(receiptId, paymentGroupTotal) {
  if (receiptId > 0) {
    return Enums.ReceiptCreateStatus.CreatedReceipt;
  } else if (paymentGroupTotal == 1) {
    return Enums.ReceiptCreateStatus.CanCreateReceipt;
  } else {
    return Enums.ReceiptCreateStatus.CanNotCreateReceipt;
  }
}
function GetStartAndEndLotMovementTable(total, pageNo, pageSize) {
  if (total && total > 0) {
    const fetch = (pageNo - 1) * pageSize;
    let start = fetch + 1;
    let end = fetch + pageSize;
    if (end > total) {
      end = total;
    }
    return { start: start, end: end };
  }
  return { start: 1, end: 1 };
}
function GetStartAndEndLotTable(total, pageNo, pageSize) {
  if (total && total > 0) {
    const fetch = (pageNo - 1) * pageSize;
    let start = total - fetch;
    let end = start - (pageSize - 1);
    if (start <= 0) {
      start = 1;
    }
    if (end <= 0) {
      end = 1;
    }
    return { start: start, end: end };
  }
  return { start: 1, end: 1 };
}
function GetLotTableFromSearchStockActivity(lotTable, stockActivityHashmap) {
  const searchedTableList = [];
  let total = 0;
  if (lotTable && lotTable.tableList) {
    for (const table of lotTable.tableList) {
      if (stockActivityHashmap[table.stockActivityId]) {
        searchedTableList.push(table);
        total++;
      }
    }
  }
  if (total > 0) {
    return {
      sequenceNumber: lotTable.sequenceNumber,
      date: lotTable.date,
      number: lotTable.number,
      costPerUnit: lotTable.costPerUnit,
      remainAmount: lotTable.remainAmount,
      remainCost: lotTable.remainCost,
      total: total,
      tableList: searchedTableList,
    };
  }
  return null;
}
function GetStockActivityHashmap(stockActivityIdList) {
  const stockActivityHashmap = {};
  if (stockActivityIdList && stockActivityIdList.length > 0) {
    for (const stockActivityId of stockActivityIdList) {
      stockActivityHashmap[stockActivityId] = true;
    }
  }
  return stockActivityHashmap;
}
function GetLotTableFromSearchStockActivityList(lotTableList, stockActivityIdList) {
  const searchedLotTableList = [];
  if (lotTableList && lotTableList.length > 0) {
    const stockActivityHashmap = GetStockActivityHashmap(stockActivityIdList);
    for (const lotTable of lotTableList) {
      const searchedLotTable = GetLotTableFromSearchStockActivity(lotTable, stockActivityHashmap);
      if (searchedLotTable) {
        searchedLotTableList.push(searchedLotTable);
      }
    }
  }
  return searchedLotTableList;
}

export const DoReloadTable = (routerName) => {
  let stid = 0;
  let pageNo = 0;
  let etiti = "";
  if (router.history && router.history.current && router.history.current.query) {
    if (router.history.current.query.stid && router.history.current.query.stid.ToNumber() > 0) {
      stid = router.history.current.query.stid.ToNumber();
    }
    if (router.history.current.query.pageNo && router.history.current.query.pageNo.ToNumber() > 0) {
      pageNo = router.history.current.query.pageNo.ToNumber();
    }
    if (router.history.current.query.etiti) {
      etiti = router.history.current.query.etiti;
    }
  }
  setTimeout(() => {
    const query = {
      emi: userInfo.MerchantId().PeakEncryption(),
      reload: Enums.ParamsReloadType.IsMain,
      setting: 0,
    };

    if (stid) {
      query["stid"] = stid;
    }

    if (pageNo) {
      query["pageNo"] = pageNo;
    }

    if (etiti) {
      query["etiti"] = etiti;
    }

    router.push({
      name: routerName,
      query: query,
    });
  });
};

export const GetDepositIdQueue = (depositIdList) => {
  let queue = new Queue();
  if (depositIdList && depositIdList.length > 0) {
    let depositIdQueueList = [];
    let count = 0;
    for (const depositId of depositIdList) {
      depositIdQueueList.push(depositId);
      count++;
      if (count == 100) {
        queue.enqueue(depositIdQueueList);
        depositIdQueueList = [];
        count = 0;
      }
    }
    if (depositIdQueueList.length > 0) {
      queue.enqueue(depositIdQueueList);
    }
  }
  return queue;
};
export const GetTransactionQueue = (transactionList) => {
  let queue = new Queue();
  if (transactionList && transactionList.length > 0) {
    for (const transaction of transactionList) {
      queue.enqueue(transaction);
    }
  }
  return queue;
};

export const GetIdListQueuePerLimit = (idList, limitPerQueue = 1000) => {
  const queue = new Queue();
  if (idList && idList.length > 0) {
    let idListPerLimit = [];
    let count = 0;
    for (const id of idList) {
      idListPerLimit.push(id);
      count++;
      if (count == limitPerQueue) {
        queue.enqueue(idListPerLimit);
        idListPerLimit = [];
        count = 0;
      }
    }
    if (idListPerLimit.length > 0) {
      queue.enqueue(idListPerLimit);
    }
  }
  return queue;
};

export const CheckPurchaseRequisitionTransactionTableListByTableStatus = (transactionStatus, tableStatus) => {
  let canReturn = true;

  switch (tableStatus) {
    case Enums.PurchaseRequisitionTableViewStatusType.Draft:
      if (transactionStatus !== Enums.PurchaseRequisitionStatus.Draft) {
        canReturn = false;
      }
      break;
    case Enums.PurchaseRequisitionTableViewStatusType.AwaitApproval:
      if (transactionStatus !== Enums.PurchaseRequisitionStatus.AwaitApproval) {
        canReturn = false;
      }
      break;
    case Enums.PurchaseRequisitionTableViewStatusType.AwaitTask:
      if (transactionStatus !== Enums.PurchaseRequisitionStatus.AwaitTask) {
        canReturn = false;
      }
      break;
    case Enums.PurchaseRequisitionTableViewStatusType.OnProcess:
      if (transactionStatus !== Enums.PurchaseRequisitionStatus.OnProcess) {
        canReturn = false;
      }
      break;
    case Enums.PurchaseRequisitionTableViewStatusType.Overdue:
      if (transactionStatus !== Enums.PurchaseRequisitionStatus.Overdue) {
        canReturn = false;
      }
      break;
    case Enums.PurchaseRequisitionTableViewStatusType.Successful:
      if (transactionStatus !== Enums.PurchaseRequisitionStatus.Successful) {
        canReturn = false;
      }
      break;
    case Enums.PurchaseRequisitionTableViewStatusType.NotApproved:
      if (transactionStatus !== Enums.PurchaseRequisitionStatus.NotApproved) {
        canReturn = false;
      }
      break;
    case Enums.PurchaseRequisitionTableViewStatusType.All:
      if (transactionStatus == Enums.PurchaseRequisitionStatus.NotApproved) {
        canReturn = false;
      }
      break;
  }
  return canReturn;
};

export const CheckDepositTransactionTableListByTableStatus = (transactionStatus, tableStatus) => {
  let canReturn = true;

  switch (tableStatus) {
    case Enums.DepositTableViewStatusType.Draft:
      if (transactionStatus !== Enums.DepositStatus.Draft) {
        canReturn = false;
      }
      break;
    case Enums.DepositTableViewStatusType.AwaitApproval:
      if (transactionStatus !== Enums.DepositStatus.AwaitApproval) {
        canReturn = false;
      }
      break;
    case Enums.DepositTableViewStatusType.WaitingPayment:
      if (transactionStatus !== Enums.DepositStatus.Outstanding) {
        canReturn = false;
      }
      break;
    case Enums.DepositTableViewStatusType.Overdue:
      if (transactionStatus !== Enums.DepositStatus.Overdue) {
        canReturn = false;
      }
      break;
    case Enums.DepositTableViewStatusType.Paid:
      if (transactionStatus !== Enums.DepositStatus.Paid) {
        canReturn = false;
      }
      break;
    case Enums.DepositTableViewStatusType.AlreadyIssued:
      if (transactionStatus !== Enums.DepositStatus.AlreadyIssued) {
        canReturn = false;
      }
      break;
  }
  return canReturn;
};

export const CheckGoodsReceiptTransactionTableListByTableStatus = (transactionStatus, tableStatus) => {
  let canReturn = true;

  switch (tableStatus) {
    case Enums.GoodsReceiptTableViewStatusType.Draft:
      if (transactionStatus !== Enums.GoodsReceiptStatus.Draft) {
        canReturn = false;
      }
      break;
    case Enums.GoodsReceiptTableViewStatusType.AwaitApproval:
      if (transactionStatus !== Enums.GoodsReceiptStatus.AwaitApproval) {
        canReturn = false;
      }
      break;
    case Enums.GoodsReceiptTableViewStatusType.Approved:
      if (transactionStatus !== Enums.GoodsReceiptStatus.Approved) {
        canReturn = false;
      }
      break;
    case Enums.GoodsReceiptTableViewStatusType.IssuedInvoiceReceipt:
      if (transactionStatus !== Enums.GoodsReceiptStatus.IssuedInvoiceReceipt) {
        canReturn = false;
      }
      break;
  }
  return canReturn;
};

export const CheckInvoiceReceiptTransactionTableListByTableStatus = (transactionStatus, tableStatus) => {
  let canReturn = true;

  switch (tableStatus) {
    case Enums.InvoiceReceiptTableViewStatusType.Draft:
      if (transactionStatus !== Enums.InvoiceReceiptStatus.Draft) {
        canReturn = false;
      }
      break;
    case Enums.InvoiceReceiptTableViewStatusType.AwaitApproval:
      if (transactionStatus !== Enums.InvoiceReceiptStatus.AwaitApproval) {
        canReturn = false;
      }
      break;
    case Enums.InvoiceReceiptTableViewStatusType.Approved:
      if (transactionStatus !== Enums.InvoiceReceiptStatus.Approved) {
        canReturn = false;
      }
      break;
    case Enums.InvoiceReceiptTableViewStatusType.WaitingPayment:
      if (transactionStatus !== Enums.InvoiceReceiptStatus.Outstanding) {
        canReturn = false;
      }
      break;
    case Enums.InvoiceReceiptTableViewStatusType.Overdue:
      if (transactionStatus !== Enums.InvoiceReceiptStatus.Overdue) {
        canReturn = false;
      }
      break;
    case Enums.InvoiceReceiptTableViewStatusType.AwaitReceipt:
      if (transactionStatus !== Enums.InvoiceReceiptStatus.Paid) {
        canReturn = false;
      }
      break;
    case Enums.InvoiceReceiptTableViewStatusType.GotReceipt:
      if (transactionStatus !== Enums.InvoiceReceiptStatus.GotReceipt) {
        canReturn = false;
      }
      break;
  }
  return canReturn;
};
//#region filter option searchAdvance

export const FilterTransactionTableListByInputSearch = (transactionNumber, transactionContactName, inputSearch) => {
  if (inputSearch) {
    const sentence = `${transactionNumber}${transactionContactName}`;
    return sentence.toLowerCase().includes(inputSearch.toLowerCase());
  }

  return true;
};

export const FilterFinanceTransactionTableListByInputSearch = (
  transactionNumber,
  transactionContactName,
  referenceNumber,
  amount,
  inputSearch
) => {
  if (inputSearch) {
    const sentence = `${transactionNumber}${transactionContactName}${referenceNumber}${amount}`;
    return sentence.includes(inputSearch);
  }

  return true;
};
export const FilterTransactionTableListByDate = (transactionDate, searchFromDate, searchToDate) => {
  if (!transactionDate) {
    return false;
  }

  const transactionDateTime = new Date(transactionDate).getTime();

  if (searchFromDate && transactionDateTime < new Date(searchFromDate).getTime()) {
    return false;
  }

  if (searchToDate && transactionDateTime > new Date(searchToDate).getTime()) {
    return false;
  }

  return true;
};

export const FilterTransactionTableListByAcceptTaskDate = (
  transactionAcceptTaskDate,
  fromAcceptTaskDate,
  toAcceptTaskDate
) => {
  if (fromAcceptTaskDate || toAcceptTaskDate) {
    if (!transactionAcceptTaskDate) {
      return false;
    }
  }

  const transactionDateTime = new Date(transactionAcceptTaskDate).getTime();

  if (fromAcceptTaskDate && transactionDateTime < new Date(fromAcceptTaskDate).getTime()) {
    return false;
  }

  if (toAcceptTaskDate && transactionDateTime > new Date(toAcceptTaskDate).getTime()) {
    return false;
  }

  return true;
};

export const FilterTransactionTableListByPaymentDate = (
  transactionDateMaxPaymentGroupDate,
  transactionDateMinPaymentGroupDate,
  searchFromDate,
  searchToDate
) => {
  if (!transactionDateMaxPaymentGroupDate || !transactionDateMinPaymentGroupDate) {
    return false;
  }

  const transactionDateMaxPaymentGroupDateTime = new Date(transactionDateMaxPaymentGroupDate).getTime();
  const transactionDateMinPaymentGroupDateTime = new Date(transactionDateMinPaymentGroupDate).getTime();

  if (searchFromDate && transactionDateMaxPaymentGroupDateTime < new Date(searchFromDate).getTime()) {
    return false;
  }

  if (searchToDate && transactionDateMinPaymentGroupDateTime > new Date(searchToDate).getTime()) {
    return false;
  }

  return true;
};

export const FilterTransactionTableListByContactId = (transactionContactId, searchContactId) => {
  if (searchContactId && searchContactId > 0 && searchContactId !== transactionContactId) {
    return false;
  }

  return true;
};
export const FilterTransactionTableListByToCurrencyUId = (transactionToCurrencyUId, searchToCurrencyUId) => {
  if (searchToCurrencyUId && searchToCurrencyUId !== transactionToCurrencyUId) {
    return false;
  }

  return true;
};
export const FilterTransactionTableListByTransactionNumber = (transactionNumber, searchTransactionNumber) => {
  if (searchTransactionNumber) {
    const sentence = `${transactionNumber}`;
    return sentence.toLowerCase().includes(searchTransactionNumber.toLowerCase());
  }
  return true;
};
export const FilterTransactionTableListByReferenceName = (transactionReferenceName, searchReferenceName) => {
  if (searchReferenceName) {
    const sentence = `${transactionReferenceName}`;
    return sentence.toLowerCase().includes(searchReferenceName.toLowerCase());
  }
  return true;
};
export const FilterTransactionTableListByNetAmount = (
  _transactionNetAmount,
  _searchFromNetAmount,
  _searchToNetAmount
) => {
  const transactionNetAmount = _transactionNetAmount ? _transactionNetAmount.ToNumber() : 0;
  const searchFromNetAmount = GetValueSearchNetAmount(_searchFromNetAmount);
  const searchToNetAmount = GetValueSearchNetAmount(_searchToNetAmount);

  if (searchFromNetAmount != null && searchToNetAmount == null) {
    return transactionNetAmount >= searchFromNetAmount;
  }

  if (searchFromNetAmount == null && searchToNetAmount != null) {
    return transactionNetAmount <= searchToNetAmount;
  }

  if (searchFromNetAmount != null && searchToNetAmount != null) {
    return transactionNetAmount >= searchFromNetAmount && transactionNetAmount <= searchToNetAmount;
  }

  return true;
};

export const FilterReconcileTableListByNetAmount = (
  _paymentTotal,
  _paymentInOutFlowType,
  _searchFromNetAmount,
  _searchToNetAmount,
  _searchPaymentInOutFlowType
) => {
  const paymentTotal = Math.abs(_paymentTotal ?? 0);
  const searchFromNetAmount =
    GetValueSearchNetAmount(_searchFromNetAmount) === null
      ? null
      : Math.abs(GetValueSearchNetAmount(_searchFromNetAmount));
  const searchToNetAmount =
    GetValueSearchNetAmount(_searchToNetAmount) === null ? null : Math.abs(GetValueSearchNetAmount(_searchToNetAmount));
  const searchPaymentInOutFlowType = _searchPaymentInOutFlowType ?? Enums.PaymentInOutFlowType.None;
  const isMatchCashFlowType =
    searchPaymentInOutFlowType === Enums.PaymentInOutFlowType.None
      ? true
      : searchPaymentInOutFlowType === _paymentInOutFlowType;

  let isMatchAmountRange = true;

  if (searchFromNetAmount != null && searchToNetAmount == null) {
    isMatchAmountRange = paymentTotal >= searchFromNetAmount;
  }

  if (searchFromNetAmount == null && searchToNetAmount != null) {
    isMatchAmountRange = paymentTotal <= searchToNetAmount;
  }

  if (searchFromNetAmount != null && searchToNetAmount != null) {
    isMatchAmountRange = paymentTotal >= searchFromNetAmount && paymentTotal <= searchToNetAmount;
  }

  return isMatchAmountRange && isMatchCashFlowType;
};

export const GetValueSearchNetAmount = (_searchNetAmount) => {
  return _searchNetAmount == null || _searchNetAmount == "" || _searchNetAmount == undefined
    ? null
    : _searchNetAmount.ToNumber();
};
export const FilterTransactionTableListByApprovedUserId = (transactionApprovedUserId, searchApprovedUserId) => {
  return !(searchApprovedUserId && searchApprovedUserId > 0 && searchApprovedUserId !== transactionApprovedUserId);
};
export const FilterTransactionTableListByCreatedUserId = (transactionCreatedUserId, searchCreatedUserId) => {
  return !(searchCreatedUserId && searchCreatedUserId > 0 && searchCreatedUserId !== transactionCreatedUserId);
};

export const FilterTransactionTableListByProductTemplateItem = (
  transactionItemList,
  searchProductTemplateIdList,
  searchIsAllProductTemplateSearch
) => {
  if (!searchProductTemplateIdList || searchProductTemplateIdList.length === 0) {
    return true;
  }

  if (!transactionItemList || transactionItemList.length === 0) {
    return false;
  }

  const searchProductTemplateIdSet = new Set(searchProductTemplateIdList);

  if (searchIsAllProductTemplateSearch) {
    return searchProductTemplateIdList.every((searchProductTemplateId) =>
      transactionItemList.some((transactionItem) => transactionItem.productTemplateId === searchProductTemplateId)
    );
  } else {
    return transactionItemList.some((transactionItem) =>
      searchProductTemplateIdSet.has(transactionItem.productTemplateId)
    );
  }
};
export const FilterTransactionTableListByDescriptionItem = (
  transactionItemList,
  searchTextTransactionItemDescription
) => {
  if (searchTextTransactionItemDescription && transactionItemList && transactionItemList.length > 0) {
    if (transactionItemList && transactionItemList.length > 0) {
      return transactionItemList.some((transactionItem) => {
        const sentence = `${transactionItem.description}`;
        return sentence.toLowerCase().includes(searchTextTransactionItemDescription.toLowerCase());
      });
    }
  }
  return true;
};
export const FilterTransactionTableListByTagIdList = (transactionTagIdList, searchTagIdList, searchIsAllTagSearch) => {
  if (!searchTagIdList || searchTagIdList.length === 0) {
    return true;
  }

  if (!transactionTagIdList || transactionTagIdList.length === 0) {
    return false;
  }

  const searchTagIdSet = new Set(searchTagIdList);

  if (searchIsAllTagSearch) {
    return searchTagIdList.every((searchTagId) => transactionTagIdList.includes(searchTagId));
  } else {
    return transactionTagIdList.some((transactionTagId) => searchTagIdSet.has(transactionTagId));
  }
};

export const FilterTransactionTableListByAllocationList = (
  transactionAllocationList,
  searchAllocationIdList,
  searchIsNotHaveAllocation,
  searchAllocationItemIdList,
  searchIsNotHaveAnyAllocation
) => {
  if (searchIsNotHaveAllocation && transactionAllocationList.length > 0) {
    return false;
  }

  if (!searchAllocationIdList || searchAllocationIdList.length === 0) {
    return true;
  }

  const transactionAllocationListMap = new Map(
    transactionAllocationList.map((transactionAllocation) => [
      transactionAllocation.allocationId,
      new Set(transactionAllocation.allocationItemList),
    ])
  );

  const allocationId = searchAllocationIdList[0];

  if (searchIsNotHaveAnyAllocation) {
    return !transactionAllocationListMap.has(allocationId);
  }

  if (transactionAllocationListMap.has(allocationId)) {
    const allocationItemList = transactionAllocationListMap.get(allocationId);

    if (!searchAllocationItemIdList || searchAllocationItemIdList.length === 0) {
      return true;
    }

    return searchAllocationItemIdList.every((searchAllocationItemId) => allocationItemList.has(searchAllocationItemId));
  }

  return false;
};
//#endregion

export const FilterSelectDepositTableListByInputSearch = (transactionNumber, transactionReferenceName, inputSearch) => {
  if (inputSearch) {
    const sentence = `${transactionNumber}${transactionReferenceName}`;
    return sentence.toLowerCase().includes(inputSearch.toLowerCase());
  }

  return true;
};
export const FilterSelectGoodsReceiptTableListByInputSearch = (
  transactionNumber,
  transactionReferenceName,
  inputSearch
) => {
  if (inputSearch) {
    const sentence = `${transactionNumber}${transactionReferenceName}`;
    return sentence.toLowerCase().includes(inputSearch.toLowerCase());
  }

  return true;
};
export const FilterSelectInvoiceReceiptTableListByInputSearch = (
  transactionNumber,
  transactionReferenceName,
  inputSearch
) => {
  if (inputSearch) {
    const sentence = `${transactionNumber}${transactionReferenceName}`;
    return sentence.toLowerCase().includes(inputSearch.toLowerCase());
  }

  return true;
};

export const CompareItem = (a, b) => {
  if (a === b) return 0;
  return a > b ? 1 : -1;
};

export const FilterFinanceTableListByInputSearch = (
  transactionNumber,
  journalNumber,
  paymentTotal,
  contactName,
  remark,
  inputSearch
) => {
  if (inputSearch) {
    const paymentTotalStr = paymentTotal >= 0 ? paymentTotal.ToNumber() : `-${paymentTotal.ToNumber()}`;
    const sentence = `${transactionNumber}${journalNumber}${paymentTotalStr}${contactName}${remark}`;
    return sentence.toLowerCase().includes(inputSearch.toLowerCase());
  }

  return true;
};

export const FilterStatementTableListByInputSearch = (paymentTransactionList, paymentTotal, remark, inputSearch) => {
  if (inputSearch) {
    let transactionNumber = "";
    if (paymentTransactionList && paymentTransactionList.length > 0) {
      for (const paymentTransaction of paymentTransactionList) {
        transactionNumber =
          transactionNumber + `${paymentTransaction.transactionNumber}${paymentTransaction.journalNumber}`;
      }
    }
    const sentence = `${transactionNumber}${paymentTotal.FormatMoney()}${remark}`;
    return sentence.toLowerCase().includes(inputSearch.toLowerCase());
  }

  return true;
};

export const FilterFinanceTableForReconcileListByInputSearch = (
  transactionNumber,
  journalNumber,
  contactName,
  remark,
  inputSearch
) => {
  if (inputSearch) {
    const sentence = `${transactionNumber}${journalNumber}${contactName}${remark}`;
    return sentence.toLowerCase().includes(inputSearch.toLowerCase());
  }

  return true;
};

export const FilterStatementTableForReconcileListByInputSearch = (transactionRemark, inputSearch) => {
  if (inputSearch) {
    const sentence = `${transactionRemark}`;
    return sentence.toLowerCase().includes(inputSearch.toLowerCase());
  }

  return true;
};

export const FilterSelectTransactionForCreatePaymentTableByInputSearch = (transactionNumber, inputSearch) => {
  if (inputSearch) {
    const sentence = `${transactionNumber}`;
    return sentence.toLowerCase().includes(inputSearch.toLowerCase());
  }
  return true;
};

export const FilterSelectTransactionForCreatePaymentTableByStatus = (transactionStatus, transactionType) => {
  switch (transactionType) {
    case Enums.TransactionType.Deposit:
      return transactionStatus >= Enums.DepositStatus.Outstanding;
      break;
    case Enums.TransactionType.Invoice:
      return transactionStatus >= Enums.InvoiceStatus.Outstanding;
      break;
    case Enums.TransactionType.DebitNote:
      return transactionStatus >= Enums.DebitNoteStatus.Approved;
      break;
    case Enums.TransactionType.BillingNote:
      return transactionStatus >= Enums.BillingNoteStatus.Outstanding;
      break;
    default:
      return false;
  }
};

export const FilterFinanceTableListByIsReconciled = (
  reconciledGroupId,
  isApproved,
  isShowReconciled,
  isShowNotApproved,
  isShowNotReconciled
) => {
  const condition = `${isShowReconciled}-${isShowNotReconciled}-${isShowNotApproved}`;

  switch (condition) {
    case "true-true-true":
      return true;

    case "false-false-false":
      return true;

    case "true-false-false":
      return reconciledGroupId > 0 && isApproved == true;

    case "false-true-false":
      return reconciledGroupId == 0;

    case "false-false-true":
      return reconciledGroupId > 0 && isApproved == false;

    case "false-true-true":
      return !(reconciledGroupId > 0 && isApproved == true);

    case "true-true-false":
      return !(reconciledGroupId > 0 && isApproved == false);

    case "true-false-true":
      return reconciledGroupId > 0;
  }
  return true;
};

export const FilterFinanceTableListByIsCashInCashOut = (paymentInOutFlowType, isShowCashIn, isShowCashOut) => {
  if (isShowCashIn && isShowCashOut) {
    return true;
  }

  if (!isShowCashIn && !isShowCashOut) {
    return true;
  }

  if (isShowCashIn && !isShowCashOut) {
    return paymentInOutFlowType === 1;
  }

  if (!isShowCashIn && isShowCashOut) {
    return paymentInOutFlowType === 2;
  }

  return true;
};

export const FilterStatementTableListByIsCashInCashOut = (paymentTotal, isShowCashIn, isShowCashOut) => {
  if (isShowCashIn && isShowCashOut) {
    return true;
  }

  if (!isShowCashIn && !isShowCashOut) {
    return true;
  }

  if (isShowCashIn && !isShowCashOut) {
    return paymentTotal >= 0;
  }

  if (!isShowCashIn && isShowCashOut) {
    return paymentTotal < 0;
  }

  return true;
};
export const CheckInputFromFinanceTableListForGetTransactionViewDetail = (financeTableList, bankAccountId) => {
  const inputForGetTransactionViewDetail = {
    inputList: [],
  };
  const inputForGetPaymentTransferViewDetail = {
    paymentGroupIdList: [],
    bankAccountId: bankAccountId,
  };
  const inputForGetChequeViewDetail = {
    chequeIdList: [],
  };

  if (financeTableList && financeTableList.length > 0) {
    for (const financeTable of financeTableList) {
      if (financeTable.paymentGroupType === Enums.PaymentGroupType.Transfer) {
        if (financeTable.paymentGroupId > 0) {
          inputForGetPaymentTransferViewDetail.paymentGroupIdList.push(financeTable.paymentGroupId);
        }
      } else if (financeTable.chequeId > 0) {
        inputForGetChequeViewDetail.chequeIdList.push(financeTable.chequeId);
      } else if (financeTable.transactionId > 0) {
        if (inputForGetTransactionViewDetail.inputList.length > 0) {
          const inputTransactionType = inputForGetTransactionViewDetail.inputList.find(
            (x) => x.transactionType == financeTable.transactionType
          );
          if (inputTransactionType) {
            inputTransactionType.transactionIdList.push(financeTable.transactionId);
          } else {
            inputForGetTransactionViewDetail.inputList.push({
              transactionType: financeTable.transactionType,
              transactionIdList: [financeTable.transactionId],
            });
          }
        } else {
          inputForGetTransactionViewDetail.inputList.push({
            transactionType: financeTable.transactionType,
            transactionIdList: [financeTable.transactionId],
          });
        }
      }
    }
  }

  return {
    inputForGetTransactionViewDetail,
    inputForGetPaymentTransferViewDetail,
    inputForGetChequeViewDetail,
  };
};

export const SetTransactionViewDetailForFinanceTable = (
  financeTableList,
  transactionTypeListForMap,
  paymentTransferViewDetailListForMap,
  chequeViewDetailListForMap
) => {
  if (financeTableList && financeTableList.length > 0) {
    for (const financeTable of financeTableList) {
      if (financeTable.paymentGroupType === Enums.PaymentGroupType.Transfer) {
        if (financeTable.paymentGroupId > 0) {
          const paymentTransferViewDetail = paymentTransferViewDetailListForMap.get(financeTable.paymentGroupId);
          if (paymentTransferViewDetail) {
            financeTable.journalId = paymentTransferViewDetail.journalId;
            financeTable.journalNumber = paymentTransferViewDetail.journalNumber;
            financeTable.contactId = paymentTransferViewDetail.contactId;
          }
        }
      } else if (financeTable.chequeId > 0) {
        const chequeViewDetail = chequeViewDetailListForMap.get(financeTable.chequeId);
        if (chequeViewDetail) {
          financeTable.journalId = chequeViewDetail.journalId;
          financeTable.journalNumber = chequeViewDetail.journalNumber;
          financeTable.contactId = chequeViewDetail.contactId;
        }
      } else if (financeTable.transactionId > 0) {
        const transactionTypeForMap = transactionTypeListForMap.get(financeTable.transactionType);
        if (transactionTypeForMap) {
          const transaction = transactionTypeForMap.get(financeTable.transactionId);
          if (transaction) {
            financeTable.transactionNumber = transaction.number;
            financeTable.contactId = transaction.contactId;
            financeTable.financeType = transaction.financeType;
            financeTable.transactionItemType = transaction.transactionItemType;
          }
        }
      }
    }
  }
};

export const CheckProductionTransactionTableListByTableStatus = (transactionIsArchived, tableStatus) => {
  let canReturn = true;

  switch (tableStatus) {
    case Enums.ProductTemplateTableViewStatusType.IsNotArchived:
      if (transactionIsArchived) {
        canReturn = false;
      }
      break;
    case Enums.ProductTemplateTableViewStatusType.IsArchived:
      if (!transactionIsArchived) {
        canReturn = false;
      }
      break;
  }
  return canReturn;
};

export const GetUpdateMultipleQuotationCompletelyTotalCount = (quotationProgressList) => {
  let totalCount = 0;

  if (quotationProgressList?.length > 0) {
    for (const quotationProgress of quotationProgressList) {
      if (!(quotationProgress.isError || quotationProgress.loadingStatus === Enums.LoadingStatusType.Success)) {
        totalCount++;
      }
    }
  }

  return totalCount;
};

export const CheckChequeFinanceTableListByTableStatus = (transactionStatus, tableStatus) => {
  let canReturn = true;
  switch (tableStatus) {
    case Enums.ChequeFinanceTableViewStatus.Waiting:
      if (transactionStatus !== Enums.ChequeStatus.Waiting) {
        canReturn = false;
      }
      break;
    case Enums.ChequeFinanceTableViewStatus.Outstanding:
      if (transactionStatus !== Enums.ChequeStatus.OutStanding) {
        canReturn = false;
      }
      break;
    case Enums.ChequeFinanceTableViewStatus.Deposited:
      if (transactionStatus !== Enums.ChequeStatus.Deposited) {
        canReturn = false;
      }
      break;
  }
  return canReturn;
};

export default {
  //#region transactionIncome
  SetHeaderTablePurchaseRequisition(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: true,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.PurchaseRequisitionTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.PurchaseRequisitionTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Request_Date",
        sortBy: Enums.PurchaseRequisitionTableView.DueDate,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.PurchaseRequisitionTableView.NetAmount,
        sortingType: null,
        width: 170,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];
    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 180,
      align: "center",
    };

    switch (transactionTableViewStatusType) {
      case Enums.PurchaseRequisitionTableViewStatusType.All:
        break;

      case Enums.PurchaseRequisitionTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.PurchaseRequisitionTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.PurchaseRequisitionTableViewStatusType.AwaitTask:
        header.pop();
        header.push(action);
        break;
      case Enums.PurchaseRequisitionTableViewStatusType.OnProcess:
        header.pop();
        header.push(action);
        break;
      case Enums.PurchaseRequisitionTableViewStatusType.Overdue:
        header.pop();
        header.push(action);
        break;
      case Enums.PurchaseRequisitionTableViewStatusType.Successful:
        header.pop();
        header.push(action);
        break;
      case Enums.PurchaseRequisitionTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsPurchaseRequisitionTable(tableStatus) {
    const isShowTableCount = tableStatus !== Enums.PurchaseRequisitionTableViewStatusType.Voided;
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.PurchaseRequisitionTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.PurchaseRequisitionTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.PurchaseRequisitionTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Table_Tap_Await_Task",
        length: 0,
        bgLengthColor: "blueOutline",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.PurchaseRequisitionTableViewStatusType.AwaitTask,
        active: false,
      },
      {
        name: "Table_Tap_On_Process",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.PurchaseRequisitionTableViewStatusType.OnProcess,
        active: false,
      },
      {
        name: "Table_Tap_Overdue",
        length: 0,
        bgLengthColor: "red",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.PurchaseRequisitionTableViewStatusType.Overdue,
        active: false,
      },
      {
        name: "Table_Tap_Successful",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: false,
        tableViewStatusType: Enums.PurchaseRequisitionTableViewStatusType.Successful,
        active: false,
      },
      {
        name: "Table_Tap_Not_Approved",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: false,
        tableViewStatusType: Enums.PurchaseRequisitionTableViewStatusType.NotApproved,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.PurchaseRequisitionTableViewStatusType.Voided,
        active: false,
      },
    ];
    //Await Matching
    return taps;
  },
  SetHeaderTableQuotation(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.QuotationTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Customer",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.QuotationTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Valid_Date",
        sortBy: Enums.QuotationTableView.DueDate,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.QuotationTableView.NetAmount,
        sortingType: null,
        width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 200,
      align: "center",
    };

    let AcceptedDate = {
      name: "Accepted_Date",
      sortBy: Enums.QuotationTableView.ActionDate,
      sortingType: null,
      width: 120,
      align: "center",
    };

    let issueAmount = {
      name: "Table_Header_Issue_Amount",
      sortBy: null,
      sortingType: null,
      width: 120,
      align: "flex-end",
    };

    switch (transactionTableViewStatusType) {
      case Enums.QuotationTableViewStatusType.All:
        break;
      case Enums.QuotationTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.QuotationTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.QuotationTableViewStatusType.Outstanding:
        header.pop();
        header.push(action);
        break;
      case Enums.QuotationTableViewStatusType.Expired:
        header.pop();
        header.push(action);
        break;
      case Enums.QuotationTableViewStatusType.Accepted:
        header.splice(4, 1, AcceptedDate);
        header.pop();
        header.push(action);
        break;
      case Enums.QuotationTableViewStatusType.Partial:
        header.splice(4, 1);
        header.pop();
        header.push(issueAmount);
        header.push(action);
        break;
      case Enums.QuotationTableViewStatusType.Completely:
        header.splice(4, 1);
        header.splice(5, 0, issueAmount);
        break;
      case Enums.QuotationTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsQuotationTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.QuotationTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.QuotationTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Table_Tap_Await_Accept",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Outstanding,
        active: false,
      },
      {
        name: "Table_Tap_Expired",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Expired,
        active: false,
        color: "textRed",
      },
      {
        name: "Table_Tap_Accepted",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Accepted,
        active: false,
      },
      {
        name: "Text_Status_Partial",
        length: 0,
        bgLengthColor: "green",
        showtableCount: true,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Partial,
        active: false,
      },
      {
        name: "Text_Status_Completely",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Completely,
        active: false,
      },
      {
        name: "Table_Tap_Rejected",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Rejected,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableDepositPayment(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: true,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.DepositTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.DepositTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Due_Date_Deposit",
        sortBy: Enums.DepositTableView.DueDate,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.DepositTableView.NetAmount,
        sortingType: null,
        width: 170,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];
    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 180,
      align: "center",
    };

    let waitingPayment = {
      name: "Table_Header_Amount_to_pay",
      sortBy: null,
      sortingType: null,
      width: 200,
      align: "flex-end",
    };
    switch (transactionTableViewStatusType) {
      case Enums.DepositTableViewStatusType.All:
        break;

      case Enums.DepositTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.DepositTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.DepositTableViewStatusType.WaitingPayment:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.DepositTableViewStatusType.Overdue:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.DepositTableViewStatusType.Paid:
      case Enums.DepositTableViewStatusType.AlreadyIssued:
      case Enums.DepositTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetHeaderTableDeposit(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: true,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.DepositTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Customer",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.DepositTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Recive_Due_Date",
        sortBy: Enums.DepositTableView.DueDate,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.DepositTableView.NetAmount,
        sortingType: null,
        width: 150,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];
    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 170,
      align: "center",
    };

    let waitingPayment = {
      name: "Table_Header_Amount_to_pay",
      sortBy: null,
      sortingType: null,
      width: 200,
      align: "flex-end",
    };
    switch (transactionTableViewStatusType) {
      case Enums.DepositTableViewStatusType.All:
        break;

      case Enums.DepositTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.DepositTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.DepositTableViewStatusType.WaitingPayment:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.DepositTableViewStatusType.Overdue:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.DepositTableViewStatusType.Paid:
      case Enums.DepositTableViewStatusType.AlreadyIssued:
      case Enums.DepositTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsDepositTable(tableStatus) {
    const isShowTableCount = tableStatus !== Enums.DepositTableViewStatusType.Voided;
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DepositTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.DepositTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.DepositTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Text_Status_Await_Received_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.DepositTableViewStatusType.WaitingPayment,
        active: false,
      },
      {
        name: "Status_Invoice_Overdue",
        length: 0,
        bgLengthColor: "red",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.DepositTableViewStatusType.Overdue,
        active: false,
        color: "textRed",
      },
      {
        name: "Text_Status_AwaitDeduct",
        length: 0,
        bgLengthColor: "green",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.DepositTableViewStatusType.Paid,
        active: false,
      },
      {
        name: "Text_Status_CompletelyDeducted",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DepositTableViewStatusType.AlreadyIssued,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DepositTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  SetTapsDepositPaymentTable(tableStatus) {
    const isShowTableCount = tableStatus !== Enums.DepositTableViewStatusType.Voided;
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DepositTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.DepositTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.DepositTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Table_Tap_Await_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.DepositTableViewStatusType.WaitingPayment,
        active: false,
      },
      {
        name: "Text_Status_Overdue_Paid",
        length: 0,
        bgLengthColor: "red",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.DepositTableViewStatusType.Overdue,
        active: false,
        color: "textRed",
      },
      {
        name: "Text_Status_AwaitDeduct",
        length: 0,
        bgLengthColor: "green",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.DepositTableViewStatusType.Paid,
        active: false,
      },
      {
        name: "Text_Status_CompletelyDeducted",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DepositTableViewStatusType.AlreadyIssued,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DepositTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableGoodsReceipt(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: true,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.GoodsReceiptTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.GoodsReceiptTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.GoodsReceiptTableView.NetAmount,
        sortingType: null,
        width: 200,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];
    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 150,
      align: "center",
    };

    switch (transactionTableViewStatusType) {
      case Enums.GoodsReceiptTableViewStatusType.All:
        break;

      case Enums.GoodsReceiptTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.GoodsReceiptTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.GoodsReceiptTableViewStatusType.Approved:
        header.pop();
        header.push(action);
        break;
      case Enums.GoodsReceiptTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsGoodsReceiptTable(tableStatus) {
    const isShowTableCount = tableStatus !== Enums.GoodsReceiptTableViewStatusType.Voided;
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.GoodsReceiptTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.GoodsReceiptTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.GoodsReceiptTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Text_Status_Await_Matching",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.GoodsReceiptTableViewStatusType.Approved,
        active: false,
      },
      {
        name: "Text_Status_Matched",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.GoodsReceiptTableViewStatusType.IssuedInvoiceReceipt,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.GoodsReceiptTableViewStatusType.Voided,
        active: false,
      },
    ];
    //Await Matching
    return taps;
  },
  SetHeaderTableInvoiceReceipt(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: true,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.InvoiceReceiptTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.InvoiceReceiptTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Recive_Due_Date",
        sortBy: Enums.InvoiceReceiptTableView.DueDate,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.InvoiceReceiptTableView.NetAmount,
        sortingType: null,
        width: 150,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];
    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 180,
      align: "center",
    };

    let waitingPayment = {
      name: "Table_Header_Amount_to_pay",
      sortBy: null,
      sortingType: null,
      width: 200,
      align: "flex-end",
    };
    switch (transactionTableViewStatusType) {
      case Enums.InvoiceReceiptTableViewStatusType.All:
        break;

      case Enums.InvoiceReceiptTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceReceiptTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceReceiptTableViewStatusType.Approved:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceReceiptTableViewStatusType.WaitingPayment:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.InvoiceReceiptTableViewStatusType.Overdue:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.InvoiceReceiptTableViewStatusType.AwaitReceipt:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceReceiptTableViewStatusType.GotReceipt:
        break;
      case Enums.InvoiceReceiptTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsInvoiceReceiptTable(tableStatus) {
    const isShowTableCount = tableStatus !== Enums.InvoiceReceiptTableViewStatusType.Voided;
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceReceiptTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.InvoiceReceiptTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.InvoiceReceiptTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Text_Status_Await_Matching",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.InvoiceReceiptTableViewStatusType.Approved,
        active: false,
      },
      {
        name: "Text_Status_Await_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.InvoiceReceiptTableViewStatusType.WaitingPayment,
        active: false,
      },
      {
        name: "Text_Status_Overdue_Received_Paid",
        length: 0,
        bgLengthColor: "red",
        showtableCount: isShowTableCount,
        tableViewStatusType: Enums.InvoiceReceiptTableViewStatusType.Overdue,
        active: false,
        color: "textRed",
      },
      {
        name: "Text_Status_AwaitReceipt",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceReceiptTableViewStatusType.AwaitReceipt,
        active: false,
      },
      {
        name: "Text_Status_GotReceipt",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceReceiptTableViewStatusType.GotReceipt,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceReceiptTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableInvoice(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.InvoiceTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Customer",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.InvoiceTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Recive_Due_Date",
        sortBy: Enums.InvoiceTableView.DueDate,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.InvoiceTableView.NetAmount,
        sortingType: null,
        width: 150,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];
    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 200,
      align: "center",
    };

    let waitingPayment = {
      name: "Table_Header_Amount_to_pay",
      sortBy: null,
      sortingType: null,
      width: 200,
      align: "flex-end",
    };
    switch (transactionTableViewStatusType) {
      case Enums.InvoiceTableViewStatusType.All:
        break;

      case Enums.InvoiceTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.WaitingPayment:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.Overdue:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.Paid:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetHeaderTableRecurring() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Recurring_Document",
        sortBy: Enums.RecurringTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Customer",
        sortBy: Enums.RecurringTableView.ContactName,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Period",
        sortBy: null,
        sortingType: null,
        width: 160,
        align: "flex-start",
      },
      {
        name: "Next_Times_Recurring",
        sortBy: Enums.RecurringTableView.RecurringNextTime,
        sortingType: null,
        width: 135,
        align: "center",
      },
      {
        name: "Table_Header_Transaction",
        sortBy: Enums.RecurringTableView.CreatedTransactionAsStatus,
        sortingType: null,
        width: 135,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: null,
        sortingType: null,
        width: 100,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 130,
        align: "flex-start",
      },
    ];

    return header;
  },
  SetTapsInvoiceTable(isAFPPackage = false) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Text_Status_Await_Received_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.WaitingPayment,
        active: false,
      },
      {
        name: "Status_Invoice_Overdue",
        length: 0,
        bgLengthColor: "red",
        showtableCount: true,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Overdue,
        active: false,
        color: "textRed",
      },
      {
        name: "Text_Status_Received_Paid",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Paid,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Voided,
        active: false,
      },
      {
        name: "Recurring_Document",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Recurring,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableReceipt(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.ReceiptTableView.Number,
        sortingType: null,
        width: 120,
        align: "flex-start",
      },
      {
        name: "Table_Header_Customer",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.ReceiptTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.ReceiptTableView.NetAmount,
        sortingType: null,
        width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 10,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 150,
      align: "center",
    };

    switch (transactionTableViewStatusType) {
      case Enums.ReceiptTableViewStatusType.All:
        break;
      case Enums.ReceiptTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.ReceiptTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.ReceiptTableViewStatusType.Approved:
        break;
      case Enums.ReceiptTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsReceiptTable(isAFPPackage = false) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.ReceiptTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.ReceiptTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.ReceiptTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Table_Tap_Received_Paid",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.ReceiptTableViewStatusType.Approved,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.ReceiptTableViewStatusType.Voided,
        active: false,
      },
      {
        name: "Recurring_Document",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.ReceiptTableViewStatusType.Recurring,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableTaxInvoice(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.TaxInvoiceTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Customer",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.TaxInvoiceTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.TaxInvoiceTableView.NetAmount,
        sortingType: null,
        width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_VAT",
        sortBy: Enums.TaxInvoiceTableView.VatTotal,
        sortingType: null,
        width: 150,
        align: "flex-end",
      },
    ];
    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 150,
      align: "center",
    };

    let status = {
      name: "Table_Header_Status",
      sortBy: null,
      sortingType: null,
      width: 80,
      align: "center",
      icon: "fas fa-angle-down",
      isShowOptopnETaxInvoice: true,
    };

    switch (transactionTableViewStatusType) {
      case Enums.TransactionTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.TransactionTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.TransactionTableViewStatusType.AwaitTaxInvoice:
        header.push(status);
        break;
      case Enums.TransactionTableViewStatusType.All:
      case Enums.TransactionTableViewStatusType.WaitingPayment:
      case Enums.TransactionTableViewStatusType.OverDue:
      case Enums.TransactionTableViewStatusType.Paid:
      case Enums.TransactionTableViewStatusType.EtaxInvoiceIssued:
      case Enums.TransactionTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsTaxInvoiceTable(isAFPPackage = false) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.TaxInvoiceTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.TaxInvoiceTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.TaxInvoiceTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Table_Tap_Issued",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.TaxInvoiceTableViewStatusType.IssuedTaxInvoice,
        active: false,
      },
      {
        name: "ETaxInvoice",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.TaxInvoiceTableViewStatusType.EtaxInvoice,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.TaxInvoiceTableViewStatusType.Voided,
        active: false,
      },
    ];

    return taps;
  },
  SetHeaderTableCreditNote(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.CreditNoteTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Customer",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.CreditNoteTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.CreditNoteTableView.NetAmount,
        sortingType: null,
        width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 150,
      align: "center",
    };

    switch (transactionTableViewStatusType) {
      case Enums.CreditNoteTableViewStatusType.Draft:
      case Enums.CreditNoteTableViewStatusType.AwaitApprove:
      case Enums.CreditNoteTableViewStatusType.Approved:
        header.pop();
        header.push(action);
        break;
    }

    return header;
  },
  SetTapsCreditNoteTable(isAFPPackage = false) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.AwaitApprove,
        active: false,
      },
      {
        name: "Table_Tap_Await_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.Approved,
        active: false,
      },
      {
        name: "Paid",
        length: 0,
        bgLengthColor: "green",
        showtableCount: false,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.Paid,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.Voided,
        active: false,
      },
    ];

    return taps;
  },
  SetHeaderTableDebitNote(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.DebitNoteTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Customer",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.DebitNoteTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Recive_Due_Date",
        sortBy: Enums.DebitNoteTableView.DueDate,
        sortingType: null,
        width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.DebitNoteTableView.NetAmount,
        sortingType: null,
        width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 180,
      align: "center",
    };

    switch (transactionTableViewStatusType) {
      case Enums.DebitNoteTableViewStatusType.Draft:
      case Enums.DebitNoteTableViewStatusType.AwaitApprove:
      case Enums.DebitNoteTableViewStatusType.Approved:
        header.pop();
        header.push(action);
        break;
    }

    return header;
  },
  SetTapsDebitNoteTable(isAFPPackage = false) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.AwaitApprove,
        active: false,
      },
      {
        name: "Table_Tap_Await_Received_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.Approved,
        active: false,
      },
      {
        name: "Table_Tap_Received_Paid",
        length: 0,
        bgLengthColor: "green",
        showtableCount: false,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.Paid,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableBillingNote(billingNoteTableViewStatusType, isCanUpdatePayment) {
    let widthAction = 180;
    let widthNetAmount = 150;
    if (
      billingNoteTableViewStatusType == Enums.BillingNoteTableViewStatusType.Overdue ||
      billingNoteTableViewStatusType == Enums.BillingNoteTableViewStatusType.WaitingPayment
    ) {
      if (!isCanUpdatePayment) {
        widthAction = 300;
        widthNetAmount = 200;
      }
    } else if (billingNoteTableViewStatusType == Enums.BillingNoteTableViewStatusType.Paid) {
      widthAction = 160;
    }
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.BillingNoteTableView.number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Customer",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.BillingNoteTableView.date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Recive_Due_Date",
        sortBy: Enums.BillingNoteTableView.dueDate,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.BillingNoteTableView.netAmount,
        sortingType: null,
        width: widthNetAmount,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: widthAction,
      align: "center",
    };

    let paidAmount = {
      name: "Table_Header_Paid_Amount",
      sortBy: null,
      sortingType: null,
      width: 180,
      align: "flex-end",
    };
    switch (billingNoteTableViewStatusType) {
      case Enums.BillingNoteTableViewStatusType.All:
        break;

      case Enums.BillingNoteTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.BillingNoteTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.BillingNoteTableViewStatusType.WaitingPayment:
        header.pop();
        header.push(paidAmount);
        header.push(action);
        break;
      case Enums.BillingNoteTableViewStatusType.Overdue:
        header.pop();
        header.push(paidAmount);
        header.push(action);
        break;
      case Enums.BillingNoteTableViewStatusType.Paid:
        header.pop();
        header.push(action);
        break;
      case Enums.BillingNoteTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsBillingNoteTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Text_Status_Await_Received_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.WaitingPayment,
        active: false,
      },
      {
        name: "Table_Tap_Received_Overdue",
        length: 0,
        bgLengthColor: "red",
        showtableCount: true,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.Overdue,
        active: false,
        color: "textRed",
      },
      {
        name: "Table_Tap_Received_Paid",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.Paid,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  //#endregion

  //#region transactionExpense
  SetHeaderTablePurchaseOrder(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.QuotationTableView.Number,
        sortingType: null,
        // width: 140,
        align: "center",
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        // width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.QuotationTableView.Date,
        sortingType: null,
        // width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.QuotationTableView.NetAmount,
        sortingType: null,
        // width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        // width: 150,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      // width: 150,
      align: "center",
    };

    let issueAmount = {
      name: "Table_Header_Issue_Amount",
      sortBy: null,
      sortingType: null,
      // width: 120,
      align: "flex-end",
    };

    switch (transactionTableViewStatusType) {
      case Enums.QuotationTableViewStatusType.All:
        break;
      case Enums.QuotationTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.QuotationTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.QuotationTableViewStatusType.Approved:
        header.pop();
        header.push(action);
        break;
      case Enums.QuotationTableViewStatusType.Partial:
      case Enums.QuotationTableViewStatusType.Completely:
        header.splice(5, 1, issueAmount);
        header.push(action);
        break;
      case Enums.QuotationTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsPurchaseOrderTable(merchantPackageRight) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.QuotationTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.QuotationTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Table_Tap_Approve",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Approved,
        active: false,
      },
      {
        name: "Text_Status_Partial",
        length: 0,
        bgLengthColor: "green",
        showtableCount: true,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Partial,
        active: false,
      },
      {
        name: "Text_Status_Completely",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Completely,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.QuotationTableViewStatusType.Voided,
        active: false,
      },
    ];

    return taps;
  },
  SetTapsContactDashboardTable() {
    let taps = [
      {
        name: "รออนุมัติ",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.ContactDashboardForTransactionStatus.AwaitApproval,
        active: true,
      },
      {
        name: "รอรับชำระ",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.ContactDashboardForTransactionStatus.OutstandingOrOverdue,
        active: false,
      },
      {
        name: "ยอมรับแล้ว",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.ContactDashboardForTransactionStatus.Approved,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableContactDashBoard(transactionType, status) {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Document_No",
        align: "flex-start",
      },
      {
        name: "Issue_Date",
        align: "center",
      },
      {
        name: "Table_Header_Due_Date",
        align: "center",
      },
      {
        name: "Text_Amount",
        align: "flex-end",
      },
      {
        name: "table_Before_Duedate",
        align: "center",
      },
    ];

    let action = {
      name: "table_Before_Duedate",
      align: "center",
    };
    let actionAmount = {
      name: "Text_Amount",
      align: "flex-end",
    };
    let actionValidDate = {
      name: "Table_Header_Valid_Date",
      align: "center",
    };

    switch (transactionType) {
      case Enums.TransactionTypeForDashboardContact.Quotation:
        header.pop();
        header.pop();
        header.pop();
        header.push(actionValidDate);
        header.push(actionAmount);
        header.push(action);
        break;

      case Enums.TransactionTypeForDashboardContact.Invoice:
      case Enums.TransactionTypeForDashboardContact.ExpenseRecord:
      case Enums.TransactionTypeForDashboardContact.PurchaseInventoryRecord:
      case Enums.TransactionTypeForDashboardContact.PurchaseAsset:
      case Enums.TransactionTypeForDashboardContact.Deposit:
      case Enums.TransactionTypeForDashboardContact.ReceiveDeposit:
        if (status === Enums.ContactDashboardForTransactionStatus.Approved) {
          header.pop();
        } else {
          header.pop();
          header.push(action);
        }

        break;
      case Enums.TransactionTypeForDashboardContact.Receipt:
        header.pop();
        header.pop();
        header.pop();
        header.push(actionAmount);
        break;
      case Enums.TransactionTypeForDashboardContact.CreditNote:
        header.pop();
        header.pop();
        header.pop();
        header.push(actionAmount);
        break;
      case Enums.TransactionTypeForDashboardContact.BillingNote:
      case Enums.TransactionTypeForDashboardContact.CombinedPaymentNote:
        if (status === Enums.ContactDashboardForTransactionStatus.Approved) {
          header.pop();
        } else {
          header.pop();
          header.push(action);
        }
        break;
      case Enums.TransactionTypeForDashboardContact.PurchaseOrder:
        header.pop();
        header.pop();
        header.pop();
        header.push(actionAmount);
        break;
      case Enums.TransactionTypeForDashboardContact.DebitNote:
        if (status === Enums.ContactDashboardForTransactionStatus.Approved) {
          header.pop();
        } else {
          header.pop();
          header.push(action);
        }
        break;
    }

    return header;
  },
  UpdateTapsContactDashboardTable(countDashboard, status) {
    let taps = [];
    let item = {};
    switch (status) {
      case Enums.ContactDashboardForTransactionStatus.AwaitApproval:
        item = {
          name: "รออนุมัติ",
          length: countDashboard,
          bgLengthColor: "gray",
          showtableCount: false,
          tableViewStatusType: 0,
          active: true,
        };
        break;
      case Enums.ContactDashboardForTransactionStatus.OutstandingOrOverdue:
        item = {
          name: "รอรับชำระ",
          length: countDashboard,
          bgLengthColor: "gray",
          showtableCount: false,
          tableViewStatusType: 0,
          active: true,
        };
        break;
      case Enums.ContactDashboardForTransactionStatus.Approved:
        item = {
          name: "ยอมรับแล้ว",
          length: countDashboard,
          bgLengthColor: "gray",
          showtableCount: false,
          tableViewStatusType: 0,
          active: true,
        };
        break;
    }
    taps.push(item);
    return taps;
  },
  SetHeaderTableExpense(transactionTableViewStatusType, isCanUpdatePayment) {
    let widthAction = 180;
    let widthNetAmount = 120;

    if (
      transactionTableViewStatusType == Enums.InvoiceTableViewStatusType.WaitingPayment ||
      transactionTableViewStatusType == Enums.InvoiceTableViewStatusType.Overdue
    ) {
      if (!isCanUpdatePayment) {
        widthNetAmount = 150;
        widthAction = 300;
      }
    }

    if (transactionTableViewStatusType == Enums.InvoiceTableViewStatusType.AwaitReceipt) {
      if (!isCanUpdatePayment) {
        widthAction = 280;
      }
    }

    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.InvoiceTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        width: 200,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.InvoiceTableView.Date,
        sortingType: null,
        width: 140,
        align: "center",
      },
      {
        name: "Table_Header_Due_Date",
        sortBy: Enums.InvoiceTableView.DueDate,
        sortingType: null,
        width: 140,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.InvoiceTableView.NetAmount,
        sortingType: null,
        width: widthNetAmount,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: widthAction,
      align: "center",
    };

    let waitingPayment = {
      name: "Table_Header_Amount_to_pay",
      sortBy: null,
      sortingType: null,
      width: widthNetAmount,
      align: "center",
    };

    let gotReceipt = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: widthAction,
      align: "center",
    };

    switch (transactionTableViewStatusType) {
      case Enums.InvoiceTableViewStatusType.All:
        break;

      case Enums.InvoiceTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.WaitingPayment:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.Overdue:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.AwaitReceipt:
        header.pop();
        header.push(gotReceipt);
        break;
      case Enums.InvoiceTableViewStatusType.GotReceipt:
        break;
      case Enums.InvoiceTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsExpenseTable(expenseType, isAFPPackage = false) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Table_Tap_Await_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.WaitingPayment,
        active: false,
      },
      {
        name: "Table_Tap_Overdue_Paid",
        length: 0,
        bgLengthColor: "red",
        showtableCount: true,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Overdue,
        active: false,
        color: "textRed",
      },
      {
        name: "Table_Tap_Await_Receipt",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.AwaitReceipt,
        active: false,
      },
      {
        name: "Table_Tap_Got_Receipt",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.GotReceipt,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Voided,
        active: false,
      },
    ];

    if (expenseType !== Enums.ExpenseType.PurchaseAsset) {
      taps.push({
        name: "Recurring_Document",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Recurring,
        active: false,
      });
    }
    return taps;
  },
  SetHeaderTablePurchaseTaxInvoice(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.TaxInvoiceTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.TaxInvoiceTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.TaxInvoiceTableView.NetAmount,
        sortingType: null,
        width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_VAT",
        sortBy: Enums.TaxInvoiceTableView.VatTotal,
        sortingType: null,
        width: 150,
        align: "flex-end",
      },
    ];
    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 180,
      align: "center",
    };
    let gotReceipt = {
      name: "Table_Header_VAT",
      sortBy: null,
      sortingType: null,
      width: 120,
      align: "center",
    };
    switch (transactionTableViewStatusType) {
      case Enums.TransactionTableViewStatusType.Draft:
      case Enums.TransactionTableViewStatusType.All:
      case Enums.TransactionTableViewStatusType.AwaitApproval:
        break;
      case Enums.TransactionTableViewStatusType.WaitingPayment:

      case Enums.TransactionTableViewStatusType.OverDue:
        header.push(action);
        break;
      case Enums.TransactionTableViewStatusType.Paid:
        header.pop();
        header.push(gotReceipt);
        break;
      case Enums.TransactionTableViewStatusType.EtaxInvoiceIssued:
      case Enums.TransactionTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsPurchaseTaxInvoiceTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.TaxInvoiceTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Await_TaxIvoice",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.TaxInvoiceTableViewStatusType.AwaitReceiveTaxInvoice,
        active: false,
      },
      {
        name: "Table_Tap_Got_TaxIvoice",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.TaxInvoiceTableViewStatusType.ReceivedTaxInvoice,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.TaxInvoiceTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableReceiptCreditNote(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.CreditNoteTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.CreditNoteTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.CreditNoteTableView.NetAmount,
        sortingType: null,
        width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 150,
      align: "center",
    };

    switch (transactionTableViewStatusType) {
      case Enums.CreditNoteTableViewStatusType.Draft:
      case Enums.CreditNoteTableViewStatusType.AwaitApprove:
      case Enums.CreditNoteTableViewStatusType.Approved:
        header.pop();
        header.push(action);
        break;
    }
    return header;
  },
  SetTapsReceiptCreditNoteTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.AwaitApprove,
        active: false,
      },
      {
        name: "Table_Tap_Await_Received_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.Approved,
        active: false,
      },
      {
        name: "Text_Status_Received_Paid",
        length: 0,
        bgLengthColor: "green",
        showtableCount: false,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.Paid,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.CreditNoteTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableReceiptDebitNote(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.DebitNoteTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.DebitNoteTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Due_Date",
        sortBy: Enums.DebitNoteTableView.DueDate,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.DebitNoteTableView.NetAmount,
        sortingType: null,
        width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 180,
      align: "center",
    };

    switch (transactionTableViewStatusType) {
      case Enums.DebitNoteTableViewStatusType.Draft:
      case Enums.DebitNoteTableViewStatusType.AwaitApprove:
      case Enums.DebitNoteTableViewStatusType.Approved:
        header.pop();
        header.push(action);
        break;
    }
    return header;
  },
  SetTapsReceiptDebitNoteTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.AwaitApprove,
        active: false,
      },
      {
        name: "Table_Tap_Await_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.Approved,
        active: false,
      },
      {
        name: "Table_Header_Paid_Amount",

        length: 0,
        bgLengthColor: "green",
        showtableCount: false,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.Paid,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DebitNoteTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableCombinedPaymentNote(billingNoteTableViewStatusType, isCanUpdatePayment) {
    let widthAction = 150;
    let widthNetAmount = 180;
    if (
      billingNoteTableViewStatusType == Enums.BillingNoteTableViewStatusType.Overdue ||
      billingNoteTableViewStatusType == Enums.BillingNoteTableViewStatusType.WaitingPayment
    ) {
      if (!isCanUpdatePayment) {
        widthNetAmount = 200;
      }
    }

    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.BillingNoteTableView.number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.BillingNoteTableView.date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Due_Date",
        sortBy: Enums.BillingNoteTableView.dueDate,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.BillingNoteTableView.netAmount,
        sortingType: null,
        width: widthNetAmount,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];
    let draftBy = {
      name: "ร่างโดย",
      sortBy: null,
      sortingType: null,
      width: 150,
      align: "flex-start",
    };
    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: widthAction,
      align: "center",
    };

    let paidAmount = {
      name: "Table_Header_Paid_Amount",
      sortBy: null,
      sortingType: null,
      width: 180,
      align: "flex-end",
    };
    switch (billingNoteTableViewStatusType) {
      case Enums.BillingNoteTableViewStatusType.All:
        break;
      case Enums.BillingNoteTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.BillingNoteTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.BillingNoteTableViewStatusType.WaitingPayment:
        header.pop();
        header.push(paidAmount);
        header.push(action);
        break;
      case Enums.BillingNoteTableViewStatusType.Overdue:
        header.pop();
        header.push(paidAmount);
        header.push(action);
        break;
      case Enums.BillingNoteTableViewStatusType.Paid:
        break;
      case Enums.BillingNoteTableViewStatusType.Voided:
        break;
    }
    return header;
  },
  SetTapsCombinedPaymentNoteTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Table_Tap_Await_Paid",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.WaitingPayment,
        active: false,
      },
      {
        name: "Table_Tap_Overdue_Paid",
        length: 0,
        bgLengthColor: "red",
        showtableCount: true,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.Overdue,
        active: false,
        color: "textRed",
      },
      {
        name: "Text_Status_Paid",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.Paid,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.BillingNoteTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableFixedAsset(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: Enums.InvoiceTableView.Number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Table_Header_Seller",
        sortBy: Enums.InvoiceTableView.Contact,
        sortingType: null,
        width: 220,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.InvoiceTableView.Date,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Due_Date",
        sortBy: Enums.InvoiceTableView.DueDate,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.InvoiceTableView.NetAmount,
        sortingType: null,
        width: 120,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
    ];
    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 150,
      align: "center",
    };

    let waitingPayment = {
      name: "Table_Header_Amount_to_pay",
      sortBy: null,
      sortingType: null,
      width: 120,
      align: "flex-end",
    };
    switch (transactionTableViewStatusType) {
      case Enums.InvoiceTableViewStatusType.All:
        break;

      case Enums.InvoiceTableViewStatusType.Draft:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.AwaitApproval:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.WaitingPayment:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.Overdue:
        header.pop();
        header.push(waitingPayment);
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.AwaitReceipt:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.GotReceipt:
        header.pop();
        header.push(action);
        break;
      case Enums.InvoiceTableViewStatusType.Voided:
        break;
    }

    return header;
  },
  SetTapsFixedAssetTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.AwaitApproval,
        active: false,
      },
      {
        name: "Table_Tap_Await_Paid",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.WaitingPayment,
        active: false,
      },
      {
        name: "Table_Tap_Overdue_Paid",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Overdue,
        active: false,
        color: "textRed",
      },
      {
        name: "Table_Tap_Await_Receipt",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.AwaitReceipt,
        active: false,
      },
      {
        name: "Table_Tap_Got_Receipt",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.GotReceipt,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.InvoiceTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  //#endregion

  UpdateTapsTableCount(tapsTable, tableCount) {
    tapsTable.forEach((item) => {
      switch (item.tableViewStatusType) {
        case Enums.TransactionTableViewStatusType.All:
          item.length = tableCount.all;
          break;
        case Enums.TransactionTableViewStatusType.Draft:
          item.length = tableCount.draft;
          break;
        case Enums.TransactionTableViewStatusType.AwaitApproval:
          item.length = tableCount.awaitApprove;
          break;
        case Enums.TransactionTableViewStatusType.WaitingPayment:
          item.length = tableCount.waitingPayment;
          break;
        case Enums.TransactionTableViewStatusType.OverDue:
          item.length = tableCount.overDue;
          break;
        case Enums.TransactionTableViewStatusType.Paid:
          item.length = tableCount.paid;
          break;
        case Enums.TransactionTableViewStatusType.EtaxInvoiceIssued:
          item.length = tableCount.etaxInvoice;
          break;
        case Enums.TransactionTableViewStatusType.Voided:
          item.length = tableCount.voided;
          break;
        case Enums.TransactionTableViewStatusType.AwaitReceipt:
          item.length = tableCount.paid;
          break;
        case Enums.TransactionTableViewStatusType.GotReceipt:
          item.length = tableCount.gotReceipt;
          break;
      }
    });
    return tapsTable;
  },
  UpdateImportTapsTableCount(tapsTable, tableCount) {
    tapsTable.forEach((item) => {
      switch (item.tableViewStatusType) {
        case Enums.ImportTableViewStatusType.All:
          item.length = tableCount.all;
          break;
        case Enums.ImportTableViewStatusType.Quotation:
          item.length = tableCount.quotation;
          break;
        case Enums.ImportTableViewStatusType.Invoice:
          item.length = tableCount.invoice;
          break;
        case Enums.ImportTableViewStatusType.Receipt:
          item.length = tableCount.receipt;
          break;
        case Enums.ImportTableViewStatusType.PurchaseOrder:
          item.length = tableCount.purchaseOrder;
          break;
        case Enums.ImportTableViewStatusType.PurchaseInventory:
          item.length = tableCount.purchaseInventory;
          break;
        case Enums.ImportTableViewStatusType.Expense:
          item.length = tableCount.expense;
          break;
        case Enums.ImportTableViewStatusType.IsDeleted:
          item.length = tableCount.voided;
          break;
      }
    });
    return tapsTable;
  },
  SetHeaderTableImport() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Import_Table_Header_No",
        sortBy: Enums.ImportTableView.code,
        sortingType: null,
        width: 190,
        align: "flex-start",
      },
      {
        name: "Import_Table_Header_Date",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Import_Table_Header_TransactionType",
        sortBy: null,
        sortingType: null,
        width: 170,
        align: "center",
      },
      {
        name: "Import_Table_Header_ImportType",
        sortBy: null,
        sortingType: null,
        width: 180,
        align: "center",
      },
      {
        name: "Import_Table_Header_ImportBy",
        sortBy: null,
        sortingType: null,
        width: 210,
        align: "flex-start",
      },
      {
        name: "Import_Table_Header_TransactionCount",
        sortBy: null,
        sortingType: null,
        width: 130,
        align: "center",
      },
      {
        name: "Import_Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "left",
      },
    ];
    return header;
  },
  SetHeaderTableImportDetail(financeType, transactionType, expenseType, importTransactionType) {
    let hiddenPurchaseTaxInvoice = true;
    let hiddenPurchaseTaxInvoiceDate = true;
    let hiddenPaymentStatus = true;
    let hiddenAccept = true;

    if (financeType == Enums.FinanceType.OutFlow && transactionType == Enums.TransactionType.Invoice) {
      if (expenseType == Enums.ExpenseType.Expense || expenseType == Enums.ExpenseType.PurchaseInventory) {
        hiddenPurchaseTaxInvoice = false;
        hiddenPurchaseTaxInvoiceDate = false;
      }
    }

    if (transactionType !== Enums.TransactionType.Quotation && transactionType !== Enums.TransactionType.Dailyjournal) {
      hiddenPaymentStatus = false;
    }

    if (importTransactionType === Enums.ImportTransactionType.ReceiptFromInvoice) {
      hiddenPaymentStatus = true;
    }

    if (transactionType == Enums.TransactionType.Quotation && financeType == Enums.FinanceType.InFlow) {
      hiddenAccept = false;
    }

    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: null,
        sortingType: null,
        width: 180,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: null,
        sortingType: null,
        width: 120,
        align: "center",
      },
      {
        name: "Table_Header_PurchaseTaxInvoice",
        sortBy: null,
        sortingType: null,
        width: 155,
        align: "center",
        hidden: hiddenPurchaseTaxInvoice,
      },
      {
        name: "Table_Header_PurchaseTaxInvoiceDate",
        sortBy: null,
        sortingType: null,
        width: 155,
        align: "center",
        hidden: hiddenPurchaseTaxInvoiceDate,
      },
      {
        name: transactionType === Enums.TransactionType.Dailyjournal ? "Table_Header_Contact" : "Table_Header_PaidTo",
        sortBy: null,
        sortingType: null,
        width: hiddenPurchaseTaxInvoiceDate ? 530 : 230,
        align: "flex-start",
      },
      {
        name: transactionType === Enums.TransactionType.Dailyjournal ? "DebitAndCredit" : "Table_Header_Net_Amount",
        sortBy: null,
        sortingType: null,
        width: 140,
        align: "flex-end",
      },
      {
        name: "Table_Header_Payment_Status",
        sortBy: null,
        sortingType: null,
        width: 110,
        align: "center",
        hidden: hiddenPaymentStatus,
      },
      {
        name: "Accept",
        sortBy: null,
        sortingType: null,
        width: 110,
        align: "center",
        hidden: hiddenAccept,
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 110,
        align: "center",
      },
    ];

    return header;
  },
  SetTapsImportTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        bgLengthColor: "gray",
        length: 0,
        showtableCount: false,
        tableViewStatusType: Enums.ImportTableViewStatusType.All,
        active: true,
        hidden: false,
      },
      {
        name: "Table_Tap_Quotation",
        bgLengthColor: "gray",
        length: 0,
        showtableCount: false,
        tableViewStatusType: Enums.ImportTableViewStatusType.Quotation,
        active: false,
        hidden: false,
      },
      {
        name: "Table_Tap_Invoice",
        bgLengthColor: "gray",
        length: 0,
        showtableCount: false,
        tableViewStatusType: Enums.ImportTableViewStatusType.Invoice,
        active: false,
        hidden: false,
      },
      {
        name: "Table_Tap_Receipt",
        bgLengthColor: "gray",
        length: 0,
        showtableCount: false,
        tableViewStatusType: Enums.ImportTableViewStatusType.Receipt,
        active: false,
        hidden: false,
      },
      {
        name: "Table_Tap_PurchaseOrder",
        bgLengthColor: "gray",
        length: 0,
        showtableCount: false,
        tableViewStatusType: Enums.ImportTableViewStatusType.PurchaseOrder,
        active: false,
        hidden: false,
      },
      {
        name: "Table_Tap_PurchaseInventory",
        bgLengthColor: "gray",
        length: 0,
        showtableCount: false,
        tableViewStatusType: Enums.ImportTableViewStatusType.PurchaseInventory,
        active: false,
        hidden: false,
      },
      {
        name: "Table_Tap_Expense",
        bgLengthColor: "gray",
        length: 0,
        showtableCount: false,
        tableViewStatusType: Enums.ImportTableViewStatusType.Expense,
        active: false,
        hidden: false,
      },
      {
        name: "Table_Tap_Receipt_From_Invoice",
        bgLengthColor: "gray",
        length: 0,
        showtableCount: false,
        tableViewStatusType: Enums.ImportTableViewStatusType.ReceiptFromInvoice,
        active: false,
        hidden: false,
      },
      {
        name: "Daily_Journal",
        bgLengthColor: "gray",
        length: 0,
        showtableCount: false,
        tableViewStatusType: Enums.ImportTableViewStatusType.Journal,
        active: false,
        hidden: false,
      },
      {
        name: "Table_Tap_Trash",
        bgLengthColor: "gray",
        length: 0,
        showtableCount: false,
        tableViewStatusType: Enums.ImportTableViewStatusType.IsDeleted,
        active: false,
        color: "textRed",
        hidden: false,
      },
    ];
    return taps;
  },
  SetHeaderTableContact() {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "No",
        sortBy: Enums.ContactTableView.code,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Name",
        sortBy: Enums.ContactTableView.name,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Group",
        sortBy: null,
        sortingType: null,
        align: "left",
      },
      {
        name: "Action",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
    ];

    return header;
  },
  SetTapsContactTable(contactTableGroupCountList = []) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        contactGroupId: 0,
        contactTableViewStatusType: Enums.ContactTableViewStatusType.All,
        tableViewStatusType: Enums.ContactTableViewStatusType.All,
        active: true,
      },

      {
        name: "Contact_Customer",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        contactGroupId: 0,
        contactTableViewStatusType: Enums.ContactTableViewStatusType.ContactCustomer,
        tableViewStatusType: Enums.ContactTableViewStatusType.ContactCustomer,
        active: false,
      },
      {
        name: "Table_Tap_Seller",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        contactGroupId: 0,
        contactTableViewStatusType: Enums.ContactTableViewStatusType.ContactSeller,
        tableViewStatusType: Enums.ContactTableViewStatusType.ContactSeller,
        active: false,
      },
      {
        name: "Disable_Status",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        contactGroupId: 0,
        contactTableViewStatusType: Enums.ContactTableViewStatusType.Achieved,
        tableViewStatusType: Enums.ContactTableViewStatusType.Achieved,
        active: false,
      },
    ];

    if (contactTableGroupCountList.length > 0) {
      contactTableGroupCountList.forEach((contactTableGroup) => {
        taps.push({
          name: contactTableGroup.contactGroupName,
          length: 0,
          color: contactTableGroup.contactGroupColor,
          description: contactTableGroup.contactGroupDescription,
          bgLengthColor: contactTableGroup.contactGroupColor,
          showtableCount: true,
          contactGroupId: contactTableGroup.contactGroupId,
          contactTableViewStatusType: Enums.ContactTableViewStatusType.CustomGroup,
          tableViewStatusType: contactTableGroup.contactGroupId,
          active: false,
        });
      });
    }

    return taps;
  },
  UpdateTapsContactTableCount(tapsTable, tableCount) {
    tapsTable.forEach((item) => {
      switch (item.tableViewStatusType) {
        case Enums.ContactTableViewStatusType.All:
          item.length = tableCount.total;
          break;
        case Enums.ContactTableViewStatusType.Achieved:
          item.length = tableCount.isDeleted;
          break;
        case Enums.ContactTableViewStatusType.ContactCustomer:
          item.length = tableCount.incomeContactCount;
          break;
        case Enums.ContactTableViewStatusType.ContactSeller:
          item.length = tableCount.expenseContactCount;
          break;
      }
    });
    return tapsTable;
  },
  SetTapsStockMovementTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        tableViewStatusType: 0,
        active: true,
      },
    ];

    return taps;
  },
  SetTapsProductTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,

        tableViewStatusType: Enums.ProductTableViewStatusType.All,
        active: true,
      },
      {
        name: "สินค้า",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,

        tableViewStatusType: Enums.ProductTableViewStatusType.Product,
        active: false,
      },
      {
        name: "บริการ",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,

        tableViewStatusType: Enums.ProductTableViewStatusType.Service,
        active: false,
      },
    ];

    return taps;
  },
  SetHeaderTableProduce(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "รหัส",
        sortBy: Enums.ProductTableView.code,
        sortingType: null,
        width: 200,
        align: "flex-start",
      },
      {
        name: "ชื่อสินค้า/บริการ",
        sortBy: Enums.ProductTableView.name,
        sortingType: null,
        width: 300,
        align: "flex-start",
      },
      {
        name: "หน่วย",
        sortBy: null,
        sortingType: null,
        width: 100,
        align: "center",
      },
      {
        name: "ยอดขายรวม",
        sortBy: Enums.ProductTableView.totalSellPrice,
        sortingType: null,
        width: 160,
        align: "center",
      },
    ];

    let purchaseAvgPrice = {
      name: "ราคาซื้อเฉลี่ย",
      sortBy: Enums.ProductTableView.purchaseAvgPrice,
      sortingType: null,
      width: 150,
      align: "flex-end",
    };

    let sellAvgPrice = {
      name: "ราคาขายเฉลี่ย",
      sortBy: Enums.ProductTableView.sellAvgPrice,
      sortingType: null,
      width: 150,
      align: "flex-end",
    };

    let remainAmount = {
      name: "จำนวนคงเหลือ",
      sortBy: Enums.ProductTableView.remainAmount,
      sortingType: null,
      width: 160,
      align: "flex-end",
    };

    switch (transactionTableViewStatusType) {
      case Enums.ProductTableViewStatusType.All:
      case Enums.ProductTableViewStatusType.Product:
        header.splice(4, 0, purchaseAvgPrice);
        header.splice(5, 0, sellAvgPrice);
        header.splice(7, 0, remainAmount);
        break;
      case Enums.ProductTableViewStatusType.Service:
        header.splice(4, 0, purchaseAvgPrice);
        break;
    }

    return header;
  },
  UpdateTapsProductTableCount(tapsTable, tableCount) {
    tapsTable.forEach((item) => {
      switch (item.tableViewStatusType) {
        case Enums.ProductTableViewStatusType.All:
          item.length = tableCount.total;
          break;
        case Enums.ProductTableViewStatusType.Product:
          item.length = tableCount.productTotal;
          break;
        case Enums.ProductTableViewStatusType.Service:
          item.length = tableCount.serviceTotal;
          break;
      }
    });
    return tapsTable;
  },
  SetHeaderTableUnit() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Unit_Code",
        sortBy: null,
        sortingType: null,
        width: 20,
        align: "flex-start",
      },
      {
        name: "Name_TH",
        sortBy: null,
        sortingType: null,
        width: 300,
        align: "flex-start",
      },
      {
        name: "Name_EN",
        sortBy: null,
        sortingType: null,
        width: 300,
        align: "flex-start",
      },
      {
        name: "",
        sortBy: null,
        sortingType: null,
        width: 20,
        align: "flex-start",
      },
    ];

    return header;
  },
  SetTapsUnitTable() {
    let taps = [
      {
        name: "Product",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: false,
        tableViewStatusType: Enums.UnitType.Product,
        active: false,
      },
      {
        name: "Service",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: false,
        tableViewStatusType: Enums.UnitType.Service,
        active: false,
      },
    ];

    return taps;
  },
  UpdateTapsUnitTable(tapsTable, total, typeUnit) {
    if (typeUnit === Enums.UnitType.Product) {
      tapsTable[0].length = total;
    } else {
      tapsTable[1].length = total;
    }
    return tapsTable;
  },
  SetTapsChartOfAccountTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        tableViewStatusType: Enums.ChartOfAccountTableStatusType.All,
        active: false,
      },
      {
        name: "Menu_FixedAsset",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        tableViewStatusType: Enums.ChartOfAccountTableStatusType.Assets,
        active: false,
      },
      {
        name: "Liabilities",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        tableViewStatusType: Enums.ChartOfAccountTableStatusType.Liabilities,
        active: false,
      },
      {
        name: "Equity",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        tableViewStatusType: Enums.ChartOfAccountTableStatusType.Equity,
        active: false,
      },
      {
        name: "Revenue",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        tableViewStatusType: Enums.ChartOfAccountTableStatusType.Revenues,
        active: false,
      },
      {
        name: "Expense",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: true,
        tableViewStatusType: Enums.ChartOfAccountTableStatusType.Expenses,
        active: false,
      },
    ];

    return taps;
  },
  SetHeaderTableChartOfAccount() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Account_Code_Header",
        sortBy: Enums.ChartOfAccountTableView.Code,
        sortingType: null,
        width: 10,
        align: "center",
      },
      {
        name: "Account_Name",
        sortBy: null,
        sortingType: null,
        width: 600,
        align: "flex-start",
      },
      // {
      //   name: "คำสั่ง",
      //   sortBy: null,
      //   sortingType: null,
      //   width: 10,
      //   align: "flex-end",
      // },
    ];

    return header;
  },
  UpdateTapsChartOfAccountTable(tapsTable, tableCount) {
    tapsTable.forEach((item) => {
      switch (item.tableViewStatusType) {
        case Enums.ChartOfAccountTableStatusType.All:
          item.length = tableCount.All;
          break;
        case Enums.ChartOfAccountTableStatusType.Assets:
          item.length = tableCount.Assets;
          break;
        case Enums.ChartOfAccountTableStatusType.Liabilities:
          item.length = tableCount.Liabilities;
          break;
        case Enums.ChartOfAccountTableStatusType.Equity:
          item.length = tableCount.Equity;
          break;
        case Enums.ChartOfAccountTableStatusType.Revenues:
          item.length = tableCount.Revenues;
          break;
        case Enums.ChartOfAccountTableStatusType.Expenses:
          item.length = tableCount.Expenses;
          break;
      }
    });
    return tapsTable;
  },
  SetHeaderTableDailyJournal(transactionTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: true,
      },
      {
        name: "JournalNumber",
        sortBy: Enums.JournalTableView.number,
        sortingType: null,
        width: 140,
        align: "flex-start",
      },
      {
        name: "Description",
        sortBy: null,
        sortingType: null,
        width: 320,
        align: "flex-start",
      },
      {
        name: "Text_Date",
        sortBy: Enums.JournalTableView.date,
        sortingType: null,
        width: 120,
        align: "center",
      },
      {
        name: "Journal",
        sortBy: null,
        sortingType: null,
        width: 100,
        align: "center",
      },
      {
        name: "DebitAndCredit",
        width: 140,
        align: "flex-end",
        sortingType: null,
        sortBy: null,
        isActiveFilter: true,
      },
    ];

    let actionStatus = {
      name: "Status",
      width: 140,
      align: "flex-start",
      sortingType: null,
      sortBy: null,
    };
    let actionEditBtn = {
      name: "Table_Header_Action",
      width: 220,
      align: "center",
      sortingType: null,
      sortBy: null,
    };
    switch (transactionTableViewStatusType) {
      case Enums.JournalTableViewStatus.AwaitRecord:
      case Enums.JournalTableViewStatus.Draft:
      case Enums.JournalTableViewStatus.AwaitApprove:
      case Enums.JournalTableViewStatus.ShouldBeCheck:
        header.push(actionEditBtn);
        break;
      case Enums.JournalTableViewStatus.Voided:
      case Enums.JournalTableViewStatus.All:
      case Enums.JournalTableViewStatus.Approve:
        header.push(actionStatus);
        break;
    }
    return header;
  },

  SetTapsDailyJournalTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.JournalTableViewStatus.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.JournalTableViewStatus.Draft,
        active: false,
      },
      {
        name: "Text_Status_Await_check",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.JournalTableViewStatus.AwaitRecord,
        active: false,
      },
      {
        name: "Table_Tap_Await_Approve",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.JournalTableViewStatus.AwaitApprove,
        active: false,
      },
      {
        name: "Table_Tap_ShouldBeCheck",
        length: 0,
        bgLengthColor: "red",
        showtableCount: true,
        tableViewStatusType: Enums.JournalTableViewStatus.ShouldBeCheck,
        active: false,
      },
      {
        name: "Table_Tap_Approve",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.JournalTableViewStatus.Approve,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.JournalTableViewStatus.Voided,
        active: false,
      },
    ];
    return taps;
  },
  UpdateDailyJournalTapsTableCount(tapsTable, tableCount) {
    tapsTable.forEach((item) => {
      switch (item.tableViewStatusType) {
        case Enums.JournalTableViewStatus.All:
          item.length = tableCount.all;
          break;
        case Enums.JournalTableViewStatus.AwaitRecord:
          item.length = tableCount.awaitRecord;
          break;
        case Enums.JournalTableViewStatus.Draft:
          item.length = tableCount.draft;
          break;
        case Enums.JournalTableViewStatus.Voided:
          item.length = tableCount.voided;
          break;
        case Enums.JournalTableViewStatus.ShouldBeCheck:
          item.length = tableCount.shouldBeCheck;
          break;
        case Enums.JournalTableViewStatus.AwaitApprove:
          item.length = tableCount.AwaitAppove;
          break;
      }
    });
    return tapsTable;
  },
  SetTapsUploadDocumentTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: false,
        tableViewStatusType: Enums.UploadTableViewStatusType.All,
        active: false,
      },
      {
        name: "Table_Tap_Not_Used_Doc",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.UploadTableViewStatusType.AwaitIssuedTransaction,
        active: false,
      },
      {
        name: "Table_Tap_Used_Doc",
        length: 0,
        bgLengthColor: "purple",
        showtableCount: false,
        tableViewStatusType: Enums.UploadTableViewStatusType.IssuedTransaction,
        active: false,
      },
      // {
      //   name: "ยกเลิก",
      //   length: 0,
      //   bgLengthColor: "purple",
      //   showtableCount: false,
      //   tableViewStatusType: Enums.UploadTableViewStatusType.Voided,
      //   active: false,
      // },
    ];

    return taps;
  },
  SetHeaderTableUploadDocumentTableCount(uploadTableViewStatusType) {
    let header = [
      {
        name: "check",
        hidden: uploadTableViewStatusType === Enums.UploadTableViewStatusType.IssuedTransaction,
        checkAll: false,
      },

      {
        name: "Table_Tap_File_Name",
        sortBy: null,
        sortingType: null,
        width: 100,
        align: "flex-start",
      },
      {
        name: "Table_Tap_Upload_Date",
        sortBy: Enums.UploadDocumentTableView.UploadDate,
        sortingType: null,
        width: 10,
        align: "center",
      },
      {
        name: "Table_Tap_Type",
        sortBy: null,
        sortingType: null,
        isActiveFilter: true,
        width: 50,
        align: "flex-start",
      },
    ];
    if (uploadTableViewStatusType === Enums.UploadTableViewStatusType.All) {
      header.push({
        name: "Table_Tap_Upload_By",
        sortBy: null,
        sortingType: null,
        width: 30,
        align: "flex-start",
      });
      header.push({
        name: "Action",
        sortBy: null,
        sortingType: null,
        width: 50,
        align: "center",
      });
    } else if (uploadTableViewStatusType === Enums.UploadTableViewStatusType.IssuedTransaction) {
      header.push({
        name: "Table_Tap_Upload_Contact",
        sortBy: null,
        sortingType: null,
        width: 30,
        align: "flex-start",
      });
      header.push({
        name: "Table_Tap_Upload_IssueDate",
        sortBy: null,
        sortingType: null,
        width: 10,
        align: "center",
      });
      header.push({
        name: "Table_Tap_Create_Doc",
        sortBy: null,
        sortingType: null,
        width: 20,
        align: "center",
      });
    } else if (uploadTableViewStatusType === Enums.UploadTableViewStatusType.AwaitIssuedTransaction) {
      header.push({
        name: "Table_Tap_Upload_By",
        sortBy: null,
        sortingType: null,
        width: 30,
        align: "flex-start",
      });
      header.push({
        name: "Action",
        sortBy: null,
        sortingType: null,
        width: 50,
        align: "center",
      });
    }
    return header;
  },
  UpdateTapsUploadDocumentTableCount(tapsTable, transactionCount, totalScanedTransaction) {
    tapsTable.forEach((item) => {
      if (item.tableViewStatusType == Enums.UploadTableViewStatusType.AwaitIssuedTransaction) {
        item.length = totalScanedTransaction;
      } else {
        item.length = transactionCount;
      }
    });
    return tapsTable;
  },
  SetTapsSelectTransactionForUploadDocument(transactionCount) {
    let taps = [
      {
        name: "ทั้งหมด",
        length: transactionCount,
        bgLengthColor: "purple",
        showtableCount: false,
        tableViewStatusType: Enums.TransactionTableViewStatusType.All,
        active: false,
      },
    ];
    return taps;
  },
  SetHeaderTableSelectTransactionForUploadDocument(fileVaultTransactionType) {
    let header = [];
    if (fileVaultTransactionType == Enums.FileVaultTransactionType.Wht) {
      header = [
        {
          name: "check",
          hidden: true,
          checkAll: false,
          isNotAutoCustomTable: true,
          isShowRadio: true,
        },
        {
          name: "Document_No",
          sortBy: null,
          sortingType: null,
          align: "flex-start",
        },
        {
          name: "Payment_Date",
          sortBy: null,
          sortingType: null,
          align: "center",
        },
        {
          name: "Header_TableUploadFile_WHT",
          sortBy: null,
          sortingType: null,
          align: "flex-end",
        },
      ];
    } else {
      header = [
        {
          name: "check",
          hidden: true,
          checkAll: false,
          isNotAutoCustomTable: true,
          isShowRadio: true,
        },
        {
          name: "Document_No",
          sortBy: null,
          sortingType: null,
          align: "flex-start",
        },
        {
          name: "Issue_Date",
          sortBy: null,
          sortingType: null,
          align: "center",
        },
        {
          name: "Amount",
          sortBy: null,
          sortingType: null,
          align: "flex-end",
        },
      ];
    }

    return header;
  },
  GetContactName(contact) {
    let contactName = "";
    if (contact) {
      contactName = contact.contactFullName;
      if (
        contact.contactType != Enums.MerchantType.OrdinaryPerson &&
        contact.contactBranchCode &&
        contact.contactBranchCode != "00000"
      ) {
        contactName += " (" + contact.contactBranchCode + ")";
      }
    }
    return contactName;
  },
  GetContactShortName(contact) {
    let contactName = "";
    if (contact) {
      contactName = contact.contactShortName;
      if (
        contact.contactType != Enums.MerchantType.OrdinaryPerson &&
        contact.contactBranchCode &&
        contact.contactBranchCode != "00000"
      ) {
        contactName += " (" + contact.contactBranchCode + ")";
      }
    }
    return contactName;
  },
  SetHeaderTableFinanceDetail(tableViewStatusType, accountTypeId, bankAccountId) {
    let header = [];
    let headerAccountingRecord = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Text_Date",
        sortBy: Enums.CashBankTableView.date,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Ref_Document_Finance",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },

      {
        name: "Table_Header_Contact",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Remark",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_CashIn_CashOut_Finance",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
        iconFilter: "fas fa-chevron-down",
        isShowOptionCashInOut: true,
      },
      {
        name: "Table_Status_Finance",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        icon: "fa fa-chevron-down",
        isShowOptopnReconcile: true,
      },
      {
        sortBy: null,
        sortingType: null,
        align: "center",
      },
    ];

    let headerStatement = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Text_Date",
        sortBy: Enums.CashBankTableView.date,
        sortingType: null,
        align: "center",
      },

      {
        name: "Document_Reconcile",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        className: "headerReconciled",
      },
      {
        name: "Remark",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_CashIn_CashOut_Finance",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
        iconFilter: "fas fa-chevron-down",
        isShowOptionCashInOut: true,
      },

      {
        name: "Table_Status_Finance",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        icon: "fas fa-chevron-down",
        isShowOptopnReconcile: true,
      },

      {
        sortBy: null,
        sortingType: null,
        align: "center",
      },
    ];

    if (tableViewStatusType == Enums.FinanceDetailTableViewStatusType.AccountingRecord) {
      if (
        (accountTypeId == Enums.BankAccountType.Bank || accountTypeId == Enums.BankAccountType.EWallet) &&
        bankAccountId > 0
      ) {
        header = headerAccountingRecord;
      } else {
        headerAccountingRecord[0].hidden = true;
        headerAccountingRecord.splice(7, 1);
        header = headerAccountingRecord;
      }
    } else if (tableViewStatusType === Enums.FinanceDetailTableViewStatusType.Statement) {
      header = headerStatement;
    }

    return header;
  },

  SetTapsFinanceDetailTable(bankAccountType) {
    let taps = [
      {
        name: "Tap_Accounting_Record",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.FinanceDetailTableViewStatusType.AccountingRecord,
        active: true,
      },
    ];
    if (bankAccountType == Enums.BankAccountType.Bank || bankAccountType == Enums.BankAccountType.EWallet) {
      taps.push({
        name: "Tap_Statement",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.FinanceDetailTableViewStatusType.Statement,
        active: false,
      });
    }

    return taps;
  },
  SetHeaderTableCheque(tableViewStatusType) {
    let header = [];
    let headerChequeReceive = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Cheque_No",
        // width: 10,
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Cheque.Text_CashDateReceive",
        // width: 150,
        sortBy: Enums.ChequeTableViewStatus.receivedDate,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Cheque.Text_Issuer",
        // width: 170,
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Ref_Finance",
        // width: 150,
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Cheque.Text_ReceiveBy",
        width: 10,
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Cheque.Text_AmountBaht",
        // width: 15,
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
    ];

    let headerChequeIssue = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Cheque_No",
        // width: 10,
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Cheque.Text_CashDateIssued",
        // width: 150,
        sortBy: Enums.ChequeTableViewStatus.receivedDate,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Cheque.Text_Receiver",
        // width: 170,
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Ref_Finance",
        // width: 150,
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Cheque.Text_PaidBy",
        width: 10,
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Cheque.Text_AmountBaht",
        // width: 15,
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
    ];
    if (tableViewStatusType == Enums.ChequeTableViewStatusType.ChequeReceive) {
      header = headerChequeReceive;
    } else {
      header = headerChequeIssue;
    }

    return header;
  },
  SetTapsChequeTable(paymentInOutFlow) {
    let taps = [];
    let tapsInFlow = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.ChequeFinanceTableViewStatus.All,
        active: true,
      },
      {
        name: "Waiting",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.ChequeFinanceTableViewStatus.Waiting,
        active: false,
      },
      {
        name: "OutStanding",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.ChequeFinanceTableViewStatus.Outstanding,
        active: false,
      },
      {
        name: "Deposited",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.ChequeFinanceTableViewStatus.Deposited,
        active: false,
      },
    ];
    let tapsOutFlow = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.ChequeFinanceTableViewStatus.All,
        active: true,
      },
      {
        name: "Waiting",
        length: 0,
        bgLengthColor: "orange",
        showtableCount: true,
        tableViewStatusType: Enums.ChequeFinanceTableViewStatus.Waiting,
        active: false,
      },
      {
        name: "OutStanding_OutFlow",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.ChequeFinanceTableViewStatus.Outstanding,
        active: false,
      },
      {
        name: "Cleared",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.ChequeFinanceTableViewStatus.Deposited,
        active: false,
      },
    ];
    if (paymentInOutFlow === Enums.PaymentInOutFlowType.CashIn) {
      taps = tapsInFlow;
    } else {
      taps = tapsOutFlow;
    }
    return taps;
  },
  SetHeaderTableChequeFinance(paymentInOutFlow, tableStatusType) {
    let header = [];
    let headerChequeInFlow = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Cheque_No",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Cheque_Date",
        sortBy: Enums.ChequeTableViewStatus.chequeDatetime,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Text_ChequeReceiveDate",
        sortBy: Enums.ChequeTableViewStatus.createPaymentDate,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Cheque.Text_Issuer",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Ref_Finance",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Cheque.Text_AmountBaht",
        sortBy: Enums.ChequeTableViewStatus.amount,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "Status",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
    ];

    let headerChequeOutFlow = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Cheque_No",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Cheque_Date",
        sortBy: Enums.ChequeTableViewStatus.chequeDatetime,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Text_ChequeIssuedDate",
        sortBy: Enums.ChequeTableViewStatus.createPaymentDate,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Cheque.Text_Receiver",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Ref_Finance",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Cheque.Text_AmountBaht",
        sortBy: Enums.ChequeTableViewStatus.amount,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "Status",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      align: "center",
    };

    let ReceiveBy = {
      name: "Table_Cheque.Text_ReceiveBy",

      sortBy: null,
      sortingType: null,
      align: "flex-start",
    };

    let paidBy = {
      name: "Table_Cheque.Text_PaidBy",

      sortBy: null,
      sortingType: null,
      align: "flex-start",
    };
    let DepositDate = {
      name: "Table_Cheque.Text_DepositDate",
      sortBy: Enums.ChequeTableViewStatus.receivedDate,
      sortingType: null,
      align: "flex-start",
    };
    let ClearedDate = {
      name: "Table_Cheque.Text_ClearedDate",
      sortBy: Enums.ChequeTableViewStatus.receivedDate,
      sortingType: null,
      align: "flex-start",
    };

    if (paymentInOutFlow === Enums.PaymentInOutFlowType.CashIn) {
      header = headerChequeInFlow;
      switch (tableStatusType) {
        case Enums.ChequeFinanceTableViewStatus.All:
          break;
        case Enums.ChequeFinanceTableViewStatus.Waiting:
          header.pop();
          header.push(action);
          break;
        case Enums.ChequeFinanceTableViewStatus.Outstanding:
          header.pop();
          header.push(action);
          break;
        case Enums.ChequeFinanceTableViewStatus.Deposited:
          header.splice(3, 1, DepositDate);
          header.splice(6, 0, ReceiveBy);
          header.pop();
          break;
      }
    } else {
      header = headerChequeOutFlow;
      switch (tableStatusType) {
        case Enums.ChequeFinanceTableViewStatus.All:
          break;
        case Enums.ChequeFinanceTableViewStatus.Waiting:
          header.pop();
          header.push(action);
          break;
        case Enums.ChequeFinanceTableViewStatus.Outstanding:
          header.pop();
          header.push(action);
          break;
        case Enums.ChequeFinanceTableViewStatus.Deposited:
          header.splice(3, 1, ClearedDate);
          header.splice(6, 0, paidBy);
          header.pop();
          break;
      }
    }

    return header;
  },
  SetTapsWhtTable(tableStatus = Enums.WhtTableViewStatusType.All) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.WhtTableViewStatusType.All,
        active: tableStatus === Enums.WhtTableViewStatusType.All,
      },
      {
        name: "Table_Tap_Normal",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.WhtTableViewStatusType.Normal,
        active: tableStatus === Enums.WhtTableViewStatusType.Normal,
      },
      {
        name: "Table_Tap_EWht",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.WhtTableViewStatusType.EWht,
        active: tableStatus === Enums.WhtTableViewStatusType.EWht,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.WhtTableViewStatusType.AllVoided,
        active: tableStatus === Enums.WhtTableViewStatusType.AllVoided,
      },
    ];

    return taps;
  },
  SetHeaderTableWhtDetail(tableStatus, paymentInOutFlowType) {
    let header = [
      {
        name: "check",
        hidden: !(
          paymentInOutFlowType === Enums.PaymentInOutFlowType.CashOut &&
          tableStatus === Enums.WhtTableViewStatusType.Normal
        ),
        checkAll: false,
      },
      {
        name: "No_Document",
        sortBy: Enums.WhtTableView.number,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: paymentInOutFlowType == Enums.PaymentInOutFlowType.CashIn ? "Customer_Name" : "Seller_Name",
        sortBy: Enums.WhtTableView.contactFullName,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Ref_Finance",
        sortBy: Enums.WhtTableView.transactionNumber,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Payment_Date",
        sortBy: Enums.WhtTableView.date,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Amount",
        sortBy: Enums.WhtTableView.subTotalForCalculateWht,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "WhtAmount",
        sortBy: Enums.WhtTableView.transactionNetAmount,
        sortingType: null,
        align: "flex-end",
      },
    ];

    switch (tableStatus) {
      case Enums.WhtTableViewStatusType.All:
        header.push({
          name: "Table_Header_Submission",
          sortBy: null,
          sortingType: null,
          align: "flex-start",
        });
        break;
      case Enums.WhtTableViewStatusType.Normal:
      case Enums.WhtTableViewStatusType.EWht:
        header.push({
          name: "Table_Header_Action",
          sortBy: null,
          sortingType: null,
          align: "center",
          isActiveFilter: true,
        });
        break;
      case Enums.WhtTableViewStatusType.AllVoided:
        break;
    }

    return header;
  },
  SetTapsUserTable() {
    let taps = [
      {
        name: "",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: 0,
        active: true,
      },
    ];
    return taps;
  },
  SetHeaderTableUser() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "TableUserSetting_UserName",
        sortBy: Enums.UserOrderBy.DisplayName,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "TableUserSetting_UserRight",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "TableUserSetting_LastLogin",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        positionTooltip: "bottom",
        tooltip: "User_Setting_Last_Login_Tooltip",
      },
      {
        name: "",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
    ];
    return header;
  },
  SetHeaderTableUserV2() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "TableUserSetting_UserName",
        sortBy: Enums.UserOrderBy.DisplayName,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "TableUserSetting_UserRight",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "TableUserSetting_LastLogin",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        positionTooltip: "bottom",
        tooltip: "User_Setting_Last_Login_Tooltip",
      },
      {
        name: "TableUserSetting_Access",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
    ];
    return header;
  },
  SetHeaderUserRoleTable() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "User_Role_Title",
        align: "flex-start",
      },
      {
        name: "User_Role_Number_Of_User_Title",
        align: "flex-start",
      },
    ];
    return header;
  },
  SetHeaderUserInvitationTable() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "TableUserSetting_UserName",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "TableUserSetting_GroupUserRight",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "TableUserSetting_Status",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "TableUserSetting_Access",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
    ];
    return header;
  },
  SetTapsAllocationTable(count) {
    const taps = [
      {
        name: "All",
        length: count,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: 0,
        active: true,
      },
    ];
    return taps;
  },
  SetHeaderAllocationTable() {
    const header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Header_Allocation_Group_No",
        sortBy: Enums.AllocationGroupTableView.Number,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Header_Allocation_Name",
        sortBy: Enums.AllocationGroupTableView.Name,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Item_only",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Header_Allocation_Document",
        sortBy: Enums.AllocationGroupTableView.AllocationDocumentFinanceType,
        sortingType: null,
        align: "center",
      },
      {
        name: "Header_Allocation_In_use",
        sortBy: Enums.AllocationGroupTableView.IsArchived,
        sortingType: null,
        align: "flex-start",
      },
    ];

    return header;
  },
  SetHeaderNewTableProduct(productType) {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Header_Code",
        sortBy: Enums.ProductTableOrder.Code,
        sortingType: null,
        align: "left",
      },
      {
        name: productType === Enums.ProductType.Inventory ? "Header_Name" : "Header_Name_Service",
        sortBy: Enums.ProductTableOrder.Name,
        sortingType: null,
        align: "left",
      },
      {
        name: "Header_Unit",
        sortBy: null,
        sortingType: null,

        align: "center",
      },
    ];

    const headerBalance = {
      name: "Header_Balance",
      sortBy: Enums.ProductTableOrder.RemainStock,
      sortingType: null,
      align: "flex-end",
    };

    const headerSalePrice = {
      name: "Header_Sale_Price",
      sortBy: Enums.ProductTableOrder.SellPrice,
      sortingType: null,
      align: "flex-end",
    };

    if (productType === Enums.ProductType.Inventory) {
      header.push(headerBalance);
      header.push(headerSalePrice);
    } else if (productType === Enums.ProductType.Service) {
      header.push(headerSalePrice);
    }
    return header;
  },
  SetTapsNewProductTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "purple",
        tableViewStatusType: Enums.ProductTemplateTableViewStatusType.IsNotArchived,
        active: true,
      },
      {
        name: "Disable_Status",
        length: 0,
        bgLengthColor: "purple",
        tableViewStatusType: Enums.ProductTemplateTableViewStatusType.IsArchived,
        active: false,
      },
    ];
    return taps;
  },
  GetSearchAdvanceTemplate() {
    return {
      allocationIdList: [],
      allocationItemIdList: [],
      approvedUserId: 0,
      contactId: 0,
      createdUserId: 0,
      fromIssueDate: null,
      toIssueDate: null,
      fromDueDate: null,
      toDueDate: null,
      fromAcceptedDate: null,
      toAcceptedDate: null,
      fromAcceptTaskDate: null,
      toAcceptTaskDate: null,
      fromPaymentDate: null,
      toPaymentDate: null,
      fromCreatedDate: null,
      toCreatedDate: null,
      fromApprovedDate: null,
      toApprovedDate: null,
      fromNetAmount: null,
      toNetAmount: null,
      isAllProductTemplateSearch: false,
      isAllFixAssetTemplateSearch: false,
      isAllTagSearch: false,
      productTemplateIdList: [],
      fixAssetTemplateIdList: [],
      receivedTaxInvoiceDate: null,
      receivedTaxInvoiceNumber: "",
      searchTextReference: "",
      searchTextTransactionItemDescription: "",
      searchTextTransactionNumber: "",
      tagIdList: [],
      isNotHaveAllocation: false,
      isNotHaveAnyAllocation: false,
    };
  },
  SetHeaderStockMovementTable(productType) {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Table_Header_Date",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Header_List",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Header_Ref",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Header_Contact",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Quantity",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "Price_Q",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "Text_TotalCost",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
    ];
    if (productType == Enums.ProductTemplateType.Product) {
      header.push({
        name: "Table_Header_Remaining",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      });
    }
    return header;
  },
  SetHeaderGeneralLedgerTransactionTable() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
        // width: 100,
      },
      {
        name: "GL_Header_Date",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        // width: 100,
      },
      {
        name: "GL_Header_Journal",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        // width: 140,
      },
      {
        name: "GL_Header_Description",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        // width: 180,
      },
      {
        name: "GL_Header_Dr",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
        // width: 100,
      },
      {
        name: "GL_Header_Cr",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
        // width: 100,
      },
      {
        name: "GL_Header_Remain",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
        // width: 100,
      },
    ];

    return header;
  },
  SetTapsGeneralLedgerTransactionTable(count) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: count,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: 0,
        active: true,
      },
    ];
    return taps;
  },
  SetChartOfAccountReferenceTable() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
        width: 100,
      },
      {
        name: "Text_SubAccount",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        width: 20,
      },
      {
        name: "Account_Name",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        width: 500,
      },
    ];

    return header;
  },
  SetTapsChartOfAccountReferenceTable(count) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: count,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: 0,
        active: true,
      },
    ];
    return taps;
  },
  SetHeaderSubscriptionHistoryTable() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Transaction",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "PricePayment",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "UserPayment",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "DatePayment",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "StatusPayment",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Subscription_History_Reciept",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Subscription_History_Attach_File_WHT",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
    ];
    return header;
  },
  SetTapsSubscriptionHistoryTable(count) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: count,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: 0,
        active: true,
      },
    ];
    return taps;
  },
  SetHeaderInvoiceForCreateBillingNoteTable() {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Document_No",
        sortBy: Enums.InvoiceForCreateBillingNoteTableView.Number,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Issue_Date",
        sortBy: Enums.InvoiceForCreateBillingNoteTableView.Date,
        sortingType: null,
        align: "center",
      },
      {
        name: "Due_Date",
        sortBy: Enums.InvoiceForCreateBillingNoteTableView.DueDate,
        sortingType: null,
        align: "center",
      },
      {
        name: "Net_Amount",
        sortBy: Enums.InvoiceForCreateBillingNoteTableView.NetAmount,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "Table_Header_Amount_to_pay",
        sortBy: Enums.InvoiceForCreateBillingNoteTableView.RemainingPayment,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "Billing_Amount",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
    ];
    return header;
  },
  SetTapsInvoiceForCreateBillingNoteTable(transactionCount) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: transactionCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: 0,
        active: true,
      },
    ];
    return taps;
  },
  SetHeaderDBDEFilingTable() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Data_No",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Current_Period",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Create_Date",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Last_Edited_Date",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
    ];
    return header;
  },
  SetHeaderCardInfoTable() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Debit_Credit_Card",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
    ];
    return header;
  },
  UpdateTapsDBDEFilingTableCount(tapsTable, tableCount) {
    tapsTable.forEach((item) => {
      switch (item.tableViewStatusType) {
        case Enums.DBDEFilingTableViewStatusType.All:
          item.length = tableCount.statusAllCount;
          break;
        case Enums.DBDEFilingTableViewStatusType.Draft:
          item.length = tableCount.statusDraftCount;
          break;
        case Enums.DBDEFilingTableViewStatusType.Approve:
          item.length = tableCount.statusApproveCount;
          break;
        case Enums.DBDEFilingTableViewStatusType.Voided:
          item.length = tableCount.statusVoidedCount;
          break;
      }
    });
    return tapsTable;
  },
  SetTapsDBDEFilingTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DBDEFilingTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.DBDEFilingTableViewStatusType.Draft,
        active: false,
      },
      {
        name: "Text_Status_Approval",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DBDEFilingTableViewStatusType.Approve,
        active: false,
      },
      {
        name: "Text_Status_Voided",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.DBDEFilingTableViewStatusType.Voided,
        active: false,
      },
    ];
    return taps;
  },
  GetTransactionPageSize() {
    let transactionPageSizeFromCookie = shareHelper.GetCookie("transactionPageSize");
    if (transactionPageSizeFromCookie != null) {
      return transactionPageSizeFromCookie.ToNumber();
    } else {
      return 10;
    }
  },
  SetTransactionPageSize(pageSize) {
    let transactionPageSizeFromCookie = shareHelper.GetCookie("transactionPageSize");
    if (transactionPageSizeFromCookie == null || pageSize != transactionPageSizeFromCookie.ToNumber()) {
      shareHelper.SetCookie("transactionPageSize", pageSize, 7);
    }
  },
  GetDailyJournalPageSize() {
    let dailyJournalPageSizeFromCookie = shareHelper.GetCookie("dailyJournalPageSize");
    if (dailyJournalPageSizeFromCookie != null) {
      return dailyJournalPageSizeFromCookie.ToNumber();
    } else {
      return 10;
    }
  },
  SetDailyJournalPageSize(pageSize) {
    let dailyJournalPageSizeFromCookie = shareHelper.GetCookie("dailyJournalPageSize");
    if (dailyJournalPageSizeFromCookie == null || pageSize != dailyJournalPageSizeFromCookie.ToNumber()) {
      shareHelper.SetCookie("dailyJournalPageSize", pageSize, 7);
    }
  },
  SetJournalTypeUrlQuery(route, journalType) {
    let query = Object.assign({}, route.query);
    query.journalType = journalType;
    router.replace({ query });
  },
  SetPageNoUrlQuery(route, pageNo) {
    let query = Object.assign({}, route.query);
    query.pageNo = pageNo;
    router.replace({ query });
  },
  SetSortBy(headerTable, sortBy, sortingType) {
    if (headerTable && headerTable.length > 0) {
      headerTable.forEach((item) => {
        if (item.sortBy == sortBy) {
          item.sortingType = sortingType;
        } else {
          item.sortingType = null;
        }
      });
    }
  },
  SetCountForTapTable(taps, tableCount, tableStatus) {
    if (taps && taps.length > 0) {
      taps.forEach((tap) => {
        if (tap.tableViewStatusType === tableStatus) {
          tap.length = tableCount;
          tap.loadCount = true;
        }
      });
    }
  },
  CheckCountByTapStatus(taps, tableStatus) {
    let loadCount = false;
    if (taps && taps.length > 0) {
      let selectTap = taps.find((x) => x.tableViewStatusType == tableStatus);
      if (selectTap) {
        loadCount = selectTap.loadCount;
      }
    }
    return loadCount ? false : true;
  },
  GetIdListTransactionForOtherData(transactionList) {
    let transactionIdList = [];
    let contactIdList = [];

    if (transactionList && transactionList.length > 0) {
      transactionList.forEach((transaction) => {
        if (transaction.id > 0) {
          transactionIdList.push(transaction.id);
        }
        if (transaction.contactId > 0) {
          contactIdList.push(transaction.contactId);
        }
      });
    }

    return { transactionIdList, contactIdList };
  },

  SetPaymentRemainingNetAmountForTransactionList(invoicePaymentList, transactionList) {
    let dataInvoicePaymentMap = new Map();
    if (invoicePaymentList && invoicePaymentList.length > 0) {
      invoicePaymentList.forEach((invoicePayment) => {
        dataInvoicePaymentMap.set(invoicePayment.id, invoicePayment.remainPaymentAmount);
      });
    }
    if (transactionList && transactionList.length > 0) {
      transactionList.forEach((transaction) => {
        let remainPayment = dataInvoicePaymentMap.get(transaction.id);
        transaction.remainPayment = remainPayment ? remainPayment : 0;
      });
    }

    dataInvoicePaymentMap.clear();
  },
  SetPaymentGroupTransactForTransactionList(paymentGroupTransactionList, transactionList, transactionType) {
    let dataPaymentGroupMap = new Map();
    if (paymentGroupTransactionList && paymentGroupTransactionList.length > 0) {
      paymentGroupTransactionList.forEach((paymentGroupTransaction) => {
        if (paymentGroupTransaction.transactionType == transactionType) {
          dataPaymentGroupMap.set(paymentGroupTransaction.transactionId, {
            receiptId: paymentGroupTransaction.receiptId,
            receiptCreateStatus: GetInvoiceReceiptCreateStatus(
              paymentGroupTransaction.receiptId,
              paymentGroupTransaction.paymentGroupTotal
            ),
          });
        }
      });
    }

    if (transactionList && transactionList.length > 0) {
      transactionList.forEach((transaction) => {
        let paymentGroup = dataPaymentGroupMap.get(transaction.id);
        if (paymentGroup) {
          transaction.referenceReceiptId = paymentGroup.receiptId;
          transaction.receiptCreateStatus = paymentGroup.receiptCreateStatus;
        } else {
          transaction.receiptCreateStatus = Enums.ReceiptCreateStatus.CanNotCreateReceipt;
        }
      });
    }

    dataPaymentGroupMap.clear();
  },

  SetQuotationReferenceInvoiceListForTransactionList(quotationReferenceInvoiceList, transactionList) {
    let dataQuotationReferenceInvoiceMap = new Map();

    if (quotationReferenceInvoiceList && quotationReferenceInvoiceList.length > 0) {
      quotationReferenceInvoiceList.forEach((quotationReferenceInvoice) => {
        dataQuotationReferenceInvoiceMap.set(
          quotationReferenceInvoice.quotationId,
          quotationReferenceInvoice.lastestInvoiceId
        );
      });
    }

    if (transactionList && transactionList.length > 0) {
      transactionList.forEach((transaction) => {
        let lastestInvoiceId = dataQuotationReferenceInvoiceMap.get(transaction.id);
        transaction.referenceInvoiceId = lastestInvoiceId ? lastestInvoiceId : 0;
      });
    }

    dataQuotationReferenceInvoiceMap.clear();
  },
  GetTransactionReportCriteria(
    tableStatus,
    sortingType,
    sortBy,
    dateSearch,
    inputSearch,
    searchAdvance,
    filterETaxInvoiceType = Enums.FilterETaxInvoiceType.None
  ) {
    const reportCriteria = {
      tableStatus: tableStatus,
      tableSorting: sortingType,
      transactionTableView: sortBy,
      fromDate: dateSearch.fromDateSearch,
      toDate: dateSearch.toDateSearch,
      searchText: inputSearch,
      filterETaxInvoiceType: filterETaxInvoiceType,
      reportTemplateType: Enums.ReportType.Basic,
      excelHeaderDetailLocation: Enums.ReportHeaderType.Top,
      isShowPurchaseOrderAsset: false,
      isShowPriceAndTaxGroup: false,
      isShowDepositReceiptGroup: false,
      isShowDepositPaymentGroup: false,
      isShowPaymentRecordGroup: false,
      isShowClassificationGroup: false,
      isShowOthersGroup: false,
      isShowHistoryGroup: false,
      isShowEtaxInvoiceStatus: false,
      isShowDeleted: false,
      transactionSearchCriteria: this.GetTransactionSearchCriteria(searchAdvance),
    };
    return reportCriteria;
  },
  GetTransactionSearchCriteria(searchAdvance) {
    let transactionSearchCriteria = {
      fromDueDate: searchAdvance.fromDueDate,
      toDueDate: searchAdvance.toDueDate,
      fromAcceptedDate: searchAdvance.fromAcceptedDate,
      toAcceptedDate: searchAdvance.toAcceptedDate,
      fromAcceptTaskDate: searchAdvance.fromAcceptTaskDate,
      toAcceptTaskDate: searchAdvance.toAcceptTaskDate,
      fromPaymentDate: searchAdvance.fromPaymentDate,
      toPaymentDate: searchAdvance.toPaymentDate,
      fromNetAmount: searchAdvance.fromNetAmount,
      toNetAmount: searchAdvance.toNetAmount,
      searchTextTransactionNumber: searchAdvance.searchTextTransactionNumber,
      searchTextReference: searchAdvance.searchTextReference,
      searchTextTransactionItemDescription: searchAdvance.searchTextTransactionItemDescription,
      productTemplateIdList: searchAdvance.productTemplateIdList,
      isAllProductTemplateSearch: searchAdvance.isAllProductTemplateSearch,
      tagIdList: searchAdvance.tagIdList,
      isAllTagSearch: searchAdvance.isAllTagSearch,
      createdUserId: searchAdvance.createdUserId,
      approvedUserId: searchAdvance.approvedUserId,
      contactId: searchAdvance.contactId,
      allocationIdList: searchAdvance.allocationIdList,
      allocationItemIdList: searchAdvance.allocationItemIdList,
      isNotHaveAllocation: searchAdvance.isNotHaveAllocation,
      isNotHaveAnyAllocation: searchAdvance.isNotHaveAnyAllocation,
      fixAssetTemplateIdList: searchAdvance.fixAssetTemplateIdList,
      isAllFixAssetTemplateSearch: searchAdvance.isAllFixAssetTemplateSearch,
      receivedTaxInvoiceNumber: searchAdvance.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: searchAdvance.receivedTaxInvoiceDate,
      fromCreatedDate: searchAdvance.fromCreatedDate,
      toCreatedDate: searchAdvance.toCreatedDate,
      fromApprovedDate: searchAdvance.fromApprovedDate,
      toApprovedDate: searchAdvance.toApprovedDate,
      fromReviewedDate: searchAdvance.fromReviewedDate,
      toReviewedDate: searchAdvance.toReviewedDate,
    };
    return transactionSearchCriteria;
  },
  GetSortingBy(sortBy, sortingType) {
    if (sortingType == null) {
      return 0;
    }
    return sortBy;
  },
  GetSortingType(sortingType) {
    if (sortingType == null) {
      return 0;
    }
    return sortingType;
  },
  GetStartAndEndLotTable(total, pageNo, pageSize) {
    return GetStartAndEndLotTable(total, pageNo, pageSize);
  },
  GetStartAndEndLotMovementTable(total, pageNo, pageSize) {
    return GetStartAndEndLotMovementTable(total, pageNo, pageSize);
  },
  GetLotTableFromSearchStockActivityList(lotTableList, stockActivityIdList) {
    return GetLotTableFromSearchStockActivityList(lotTableList, stockActivityIdList);
  },
  SetHeaderTableSelectDeposit() {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
        isNotAutoCustomTable: true,
      },
      {
        name: "",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Table_Header_DocNo",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Refer_to",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Remaining_Amount_Deposit",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
        positionTooltip: "left",
        tooltip: "Remaining_Amount_Deposit_Tooltip",
      },
      {
        name: "Deducted_Amount",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
    ];

    return header;
  },
  SetHeaderTableSelectGoodsReceipt() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
        isNotAutoCustomTable: true,
        isShowRadio: true,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Refer_to",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Remaining_Amount_IR_GR",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
        positionTooltip: "left",
        tooltip: "Remaining_Amount_IR_GR_Tooltip",
      },
    ];

    return header;
  },
  SetHeaderTableSelectInvoiceReceipt() {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
        isNotAutoCustomTable: true,
        isShowRadio: true,
      },
      {
        name: "Table_Header_DocNo",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Refer_to",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Amount_Before_Deposit",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
        positionTooltip: "left",
      },
      {
        name: "Remaining_Amount_IR_GR",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
        positionTooltip: "left",
        tooltip: "Remaining_Amount_IR_GR_Tooltip",
      },
    ];

    return header;
  },
  SetTapsSelectDepositTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.SelectDepositTableViewStatusType.All,
        active: true,
      },
    ];
    return taps;
  },
  SetTapsSelectGoodsReceiptTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.SelectGoodsReceiptTableViewStatusType.All,
        active: true,
      },
    ];
    return taps;
  },
  SetTapsSelectInvoiceReceiptTable() {
    let taps = [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.SelectInvoiceReceiptTableViewStatusType.All,
        active: true,
      },
    ];
    return taps;
  },
  SetPaymentTransferTabList() {
    return [
      {
        name: "Table_Tap_All",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.PaymentTransferTableViewStatusType.All,
        active: true,
      },
      {
        name: "Table_Tap_Draft",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: true,
        tableViewStatusType: Enums.PaymentTransferTableViewStatusType.Draft,
        active: false,
      },
      // Request to hide Await for transfer tab (AwaitToPay)
      {
        name: "Table_Tap_Await_for_transfer",
        length: 0,
        bgLengthColor: "blue",
        showtableCount: true,
        tableViewStatusType: Enums.PaymentTransferTableViewStatusType.AwaitToPay,
        active: false,
        isHidden: true,
      },
      {
        name: "Table_Tap_Transferred",
        length: 0,
        bgLengthColor: "green",
        showtableCount: true,
        tableViewStatusType: Enums.PaymentTransferTableViewStatusType.Paid,
        active: false,
      },
      {
        name: "Table_Tap_Trash",
        length: 0,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.ReceiptTableViewStatusType.Voided, // Trash
        active: false,
      },
    ];
  },
  SetHeaderTablePaymentTransfer(statusType) {
    let header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Table_Header_Transfer_No",
        sortBy: null,
        sortingType: null,
        width: 200,
        align: "flex-start",
      },
      {
        name: "Table_Header_Issued_Date",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
      {
        name: "Table_Header_Transfer_Date",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-start",
      },
      {
        name: "Table_Header_Number_of_Doc",
        sortBy: null,
        sortingType: null,
        width: 130,
        align: "flex-end",
      },
      {
        name: "Table_Header_Amount_Num",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "flex-end",
      },
      {
        name: "Table_Header_Status",
        sortBy: null,
        sortingType: null,
        width: 200,
        align: "flex-start",
      },
    ];

    let action = {
      name: "Table_Header_Action",
      sortBy: null,
      sortingType: null,
      width: 200,
      align: "center",
    };

    switch (statusType) {
      case Enums.PaymentTransferTableViewStatusType.All:
      case Enums.PaymentTransferTableViewStatusType.Paid:
        break;
      case Enums.PaymentTransferTableViewStatusType.Draft:
      case Enums.PaymentTransferTableViewStatusType.AwaitToPay:
        header.pop();
        header.push(action);
        break;
    }

    return header;
  },
  SetHeaderTableSelectPaymentTransfer() {
    return [
      {
        name: "check",
        hidden: false,
        checkAll: false,
      },
      {
        name: "Table_Header_DocNo_full",
        sortBy: Enums.SelectTransactionTableView.Number,
        sortingType: null,
        align: "flex-start",
        width: 180,
      },
      {
        name: "Table_Header_Seller",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
        width: 140,
      },
      {
        name: "Table_Header_Bank",
        sortBy: null,
        sortingType: null,
        align: "center",
        width: 80,
      },
      {
        name: "Table_Header_Issue_Date",
        sortBy: Enums.SelectTransactionTableView.CreateDate,
        sortingType: null,
        align: "center",
        width: 120,
      },
      {
        name: "Due_Date",
        sortBy: Enums.SelectTransactionTableView.DueDate,
        sortingType: null,
        align: "center",
        width: 140,
      },
      {
        name: "Table_Header_Net_Amount",
        sortBy: Enums.SelectTransactionTableView.NetAmount,
        sortingType: null,
        align: "flex-end",
        width: 140,
      },
      {
        name: "Table_Header_Amount_to_pay",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
        width: 140,
      },
    ];
  },
  GetConvertedSettingTableSortColumnToTableView(sortColumnType, documentType) {
    let tableViewMapper = {};

    switch (documentType) {
      case Enums.SettingTableDocumentType.Quotation:
      case Enums.SettingTableDocumentType.PurchaseOrder:
      case Enums.SettingTableDocumentType.PurchaseOrderAsset:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.QuotationTableView.Date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.QuotationTableView.Id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.QuotationTableView.Number,
        };
        break;
      case Enums.SettingTableDocumentType.DepositReceipt:
      case Enums.SettingTableDocumentType.DepositPayment:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.DepositTableView.Date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.DepositTableView.Id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.DepositTableView.Number,
        };
        break;
      case Enums.SettingTableDocumentType.Invoice:
      case Enums.SettingTableDocumentType.PurchaseInventoryRecord:
      case Enums.SettingTableDocumentType.ExpenseRecord:
      case Enums.SettingTableDocumentType.PurchaseAsset:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.InvoiceTableView.Date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.InvoiceTableView.Id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.InvoiceTableView.Number,
        };
        break;
      case Enums.SettingTableDocumentType.Receipt:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.ReceiptTableView.Date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.ReceiptTableView.Id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.ReceiptTableView.Number,
        };
        break;
      case Enums.SettingTableDocumentType.SalesTaxInvoice:
      case Enums.SettingTableDocumentType.PurchaseTaxInvoice:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.TaxInvoiceTableView.Date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.TaxInvoiceTableView.Id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.TaxInvoiceTableView.Number,
        };
        break;
      case Enums.SettingTableDocumentType.CreditNote:
      case Enums.SettingTableDocumentType.ReceiveCreditNote:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.CreditNoteTableView.Date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.CreditNoteTableView.Id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.CreditNoteTableView.Number,
        };
        break;
      case Enums.SettingTableDocumentType.DebitNote:
      case Enums.SettingTableDocumentType.ReceiveDebitNote:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.DebitNoteTableView.Date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.DebitNoteTableView.Id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.DebitNoteTableView.Number,
        };
        break;
      case Enums.SettingTableDocumentType.BillingNote:
      case Enums.SettingTableDocumentType.CombinedPaymentNote:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.BillingNoteTableView.date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.BillingNoteTableView.id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.BillingNoteTableView.number,
        };
        break;
      case Enums.SettingTableDocumentType.GoodsReceipt:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.GoodsReceiptTableView.Date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.GoodsReceiptTableView.Id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.GoodsReceiptTableView.Number,
        };
        break;
      case Enums.SettingTableDocumentType.InvoiceReceipt:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.InvoiceReceiptTableView.Date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.InvoiceReceiptTableView.Id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.InvoiceReceiptTableView.Number,
        };
        break;
      case Enums.SettingTableDocumentType.DailyJournal:
        tableViewMapper = {
          [Enums.SettingTableSortColumnType.IssuedDate]: Enums.JournalTableView.date,
          [Enums.SettingTableSortColumnType.CreatedDate]: Enums.JournalTableView.id,
          [Enums.SettingTableSortColumnType.DocumentNumber]: Enums.JournalTableView.number,
        };
        break;
    }

    return tableViewMapper[sortColumnType] === undefined ? 0 : tableViewMapper[sortColumnType];
  },
  GetConvertedTableViewToSettingTableSortColumn(tableViewType, documentType) {
    let sortColumnMapper = {};

    switch (documentType) {
      case Enums.SettingTableDocumentType.PurchaseRequisition:
        sortColumnMapper = {
          [Enums.PurchaseRequisitionTableView.Date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.PurchaseRequisitionTableView.Id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.PurchaseRequisitionTableView.Number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.Quotation:
      case Enums.SettingTableDocumentType.PurchaseOrder:
      case Enums.SettingTableDocumentType.PurchaseOrderAsset:
        sortColumnMapper = {
          [Enums.QuotationTableView.Date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.QuotationTableView.Id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.QuotationTableView.Number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.DepositReceipt:
      case Enums.SettingTableDocumentType.DepositPayment:
        sortColumnMapper = {
          [Enums.DepositTableView.Date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.DepositTableView.Id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.DepositTableView.Number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.Invoice:
      case Enums.SettingTableDocumentType.PurchaseInventoryRecord:
      case Enums.SettingTableDocumentType.ExpenseRecord:
      case Enums.SettingTableDocumentType.PurchaseAsset:
        sortColumnMapper = {
          [Enums.InvoiceTableView.Date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.InvoiceTableView.Id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.InvoiceTableView.Number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.Receipt:
        sortColumnMapper = {
          [Enums.ReceiptTableView.Date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.ReceiptTableView.Id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.ReceiptTableView.Number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.SalesTaxInvoice:
      case Enums.SettingTableDocumentType.PurchaseTaxInvoice:
        sortColumnMapper = {
          [Enums.TaxInvoiceTableView.Date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.TaxInvoiceTableView.Id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.TaxInvoiceTableView.Number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.CreditNote:
      case Enums.SettingTableDocumentType.ReceiveCreditNote:
        sortColumnMapper = {
          [Enums.CreditNoteTableView.Date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.CreditNoteTableView.Id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.CreditNoteTableView.Number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.DebitNote:
      case Enums.SettingTableDocumentType.ReceiveDebitNote:
        sortColumnMapper = {
          [Enums.DebitNoteTableView.Date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.DebitNoteTableView.Id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.DebitNoteTableView.Number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.BillingNote:
      case Enums.SettingTableDocumentType.CombinedPaymentNote:
        sortColumnMapper = {
          [Enums.BillingNoteTableView.date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.BillingNoteTableView.id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.BillingNoteTableView.number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.GoodsReceipt:
        sortColumnMapper = {
          [Enums.GoodsReceiptTableView.Date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.GoodsReceiptTableView.Id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.GoodsReceiptTableView.Number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.InvoiceReceipt:
        sortColumnMapper = {
          [Enums.InvoiceReceiptTableView.Date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.InvoiceReceiptTableView.Id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.InvoiceReceiptTableView.Number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
      case Enums.SettingTableDocumentType.DailyJournal:
        sortColumnMapper = {
          [Enums.JournalTableView.date]: Enums.SettingTableSortColumnType.IssuedDate,
          [Enums.JournalTableView.id]: Enums.SettingTableSortColumnType.CreatedDate,
          [Enums.JournalTableView.number]: Enums.SettingTableSortColumnType.DocumentNumber,
        };
        break;
    }

    return sortColumnMapper[tableViewType] === undefined ? 0 : sortColumnMapper[tableViewType];
  },
  GetDatePeriodFromSettingTable(issuedDatePeriodType) {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();

    let fromDate, toDate;

    switch (issuedDatePeriodType) {
      case Enums.SettingTableIssuedDatePeriodType.ThisMonth:
        fromDate = new Date(currentYear, currentMonth, 1);
        toDate = new Date(currentYear, currentMonth + 1, 0);
        break;
      case Enums.SettingTableIssuedDatePeriodType.LastMonth:
        fromDate = new Date(currentYear, currentMonth - 1, 1);
        toDate = new Date(currentYear, currentMonth, 0);
        break;
      case Enums.SettingTableIssuedDatePeriodType.ThisMonthAndLastMonth:
        fromDate = new Date(currentYear, currentMonth - 1, 1);
        toDate = new Date(currentYear, currentMonth + 1, 0);
        break;
      case Enums.SettingTableIssuedDatePeriodType.ThisQuarter: {
        const quarterStartMonth = Math.floor(currentMonth / 3) * 3;
        fromDate = new Date(currentYear, quarterStartMonth, 1);
        toDate = new Date(currentYear, quarterStartMonth + 3, 0);
        break;
      }
      case Enums.SettingTableIssuedDatePeriodType.LastQuarter: {
        const quarterStartMonth = Math.floor(currentMonth / 3) * 3 - 3;
        const year = quarterStartMonth < 0 ? currentYear - 1 : currentYear;
        const adjustedStartMonth = (quarterStartMonth + 12) % 12;
        fromDate = new Date(year, adjustedStartMonth, 1);
        toDate = new Date(year, adjustedStartMonth + 3, 0);
        break;
      }
      case Enums.SettingTableIssuedDatePeriodType.ThisQuarterAndLastQuarter: {
        const thisQuarterStartMonth = Math.floor(currentMonth / 3) * 3;
        const lastQuarterStartMonth = thisQuarterStartMonth - 3;
        const lastQuarterYear = lastQuarterStartMonth < 0 ? currentYear - 1 : currentYear;
        const adjustedStartMonth = (lastQuarterStartMonth + 12) % 12;

        fromDate = new Date(lastQuarterYear, adjustedStartMonth, 1);
        toDate = new Date(currentYear, thisQuarterStartMonth + 3, 0);
        break;
      }
      case Enums.SettingTableIssuedDatePeriodType.ThisYear:
        fromDate = new Date(currentYear, 0, 1);
        toDate = new Date(currentYear, 11, 31);
        break;
      case Enums.SettingTableIssuedDatePeriodType.LastYear:
        fromDate = new Date(currentYear - 1, 0, 1);
        toDate = new Date(currentYear - 1, 11, 31);
        break;
      case Enums.SettingTableIssuedDatePeriodType.ThisYearAndLastYear:
        fromDate = new Date(currentYear - 1, 0, 1);
        toDate = new Date(currentYear, 11, 31);
        break;
      default:
        fromDate = new Date(currentYear, 0, 1);
        toDate = new Date(currentYear, 11, 31);
        break;
    }

    return { fromDate, toDate };
  },
  SetTapsSelectTransactionPaymentTransferTable(transactionCount) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: transactionCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: Enums.PaymentTransferTableViewStatusType.All,
        active: true,
      },
    ];
    return taps;
  },
  SetHeaderSelectTransactionForCreatePaymentTable() {
    let header = [
      {
        name: "check",
        hidden: false,
        checkAll: false,
        checkAllDisabled: true,
        isNotAutoCustomTable: true,
      },
      {
        name: "Document_No",
        sortBy: Enums.TransactionForCreatePaymentTableView.Number,
        sortingType: null,
        align: "flex-start",
      },
      {
        name: "Issue_Date",
        sortBy: Enums.TransactionForCreatePaymentTableView.Date,
        sortingType: null,
        align: "center",
      },
      {
        name: "Due_Date",
        sortBy: Enums.TransactionForCreatePaymentTableView.DueDate,
        sortingType: null,
        align: "center",
      },
      {
        name: "Net_Amount",
        sortBy: Enums.TransactionForCreatePaymentTableView.NetAmount,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "Table_Header_Amount_to_pay",
        sortBy: Enums.TransactionForCreatePaymentTableView.RemainingPayment,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "Pay_Amount",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
    ];
    return header;
  },
  SetTapsSelectTransactionForCreatePaymentTable(transactionCount) {
    let taps = [
      {
        name: "Table_Tap_All",
        length: transactionCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: 0,
        active: true,
      },
    ];
    return taps;
  },
};
